import React, { useEffect, useRef, useState } from 'react';
import {
  Row,
  Col,
  Form,
  Card,
  Space,
  DatePicker,
  Select,
  Radio,
  message,
  Spin,
  Tag,
  Input,
  Button,
  Tooltip
} from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import CustomButton from '@/common/CustomButton';
import { history } from 'app/history';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import CustomTable from '@/common/Content/CustomTable';
// import LocalStorage from 'utilities/localStorage';
import {
  getAllReports,
  getFailedLoginReports,
  DownloadAuditReport,
  getPoNumbers,
  getStage1Batches,
  fetchMaterialReceiptAuditTrail,
  downloadMaterialReceiptAuditPdf,
  fetchMaterialReceiptAuditCandidates,
  fetchMaterialReceiptRangeCandidates,
  downloadMaterialReceiptCombinedPdf,
  fetchWipLabelCandidates,
  fetchWipLabelTimeline,
  downloadWipLabelPdf,
  fetchMscLabelCandidates,
  fetchMscLabelTimeline,
  downloadMscLabelPdf,
  fetchMoveMaterialAuditCandidates,
  fetchMoveMaterialAuditTrail,
  downloadMoveMaterialAuditPdf,
  fetchMrrAuditCandidates,
  fetchMrrAuditTrail,
  downloadMrrAuditPdf,
  fetchLcMatVerCandidates,
  fetchLcMatVerTimeline,
  downloadLcMatVerPdf,
  fetchProdVerCandidates,
  fetchProdVerTimeline,
  downloadProdVerPdf,
  getEqpLogEquipmentIds
} from '../../redux/slice';
import CustomModal from '@/common/CustomModal';
import { getAllDispenses } from '@/features/dispensing/redux/slice';
import Layout from '@/common/Layout';
import {
  DownloadOutlined,
  SearchOutlined,
  InfoCircleOutlined
} from '@ant-design/icons';
import { getAllMaterialslist } from '@/features/stockCard/redux/slice';
import { getAllContainerRooms } from '@/features/logBooks/redux/slice';
import LocalStorage from 'utilities/localStorage';
//import { handleGetAllMaterialsList}
// import LocalStorage from 'utilities/localStorage';

const { RangePicker } = DatePicker;
// const dateFormat = 'YYYY-MM-DD';

// --- User Log Report: display mappings ---
const USER_LOG_ACTION_LABELS = {
  create: 'Account Created',
  update: 'Account Updated',
  deactivate: 'Account Deactivated',
  reactivate: 'Account Reactivated',
  delete: 'Account Deactivated',
  password_change: 'Password Changed',
  password_change_failed: 'Password Change Failed',
  password_reuse_attempt: 'Password Reuse Blocked',
  password_change_unauthorized: 'Unauthorized Password Change Attempt',
  password_complexity_rejected: 'Password Change Rejected (Complexity)',
  password_confirm_mismatch: 'Password Change Rejected (Confirm Mismatch)',
  first_login_completed: 'First Login Completed',
  auto_lockout: 'Account Auto-Locked',
  password_expired: 'Password Expired',
  password_reset_by_user: 'Password Reset (Expiry Cleared)',
  password_reset_requested: 'Password Reset Requested',
  esig_failed: 'E-Signature Failed'
};

const USER_LOG_FIELD_LABELS = {
  first_name: 'First Name',
  last_name: 'Last Name',
  middle_name: 'Middle Name',
  email: 'Email Address',
  employee_id: 'Employee ID',
  department: 'Department',
  department_id: 'Department',
  designation_id: 'Designation',
  level: 'Permission Level',
  role: 'Role',
  date_of_birth: 'Date of Birth',
  is_active: 'Account Status',
  is_verified: 'Account Verification',
  is_expired: 'Password Status',
  change_password: 'Password',
  forgot_password: 'Password',
  password_reset_requested: 'Password Reset',
  delete_user: 'Account Status'
};

const formatUserLogValue = (val, field) => {
  if (val === null || val === undefined || val === '') return '—';
  // Password fields — always show [PROTECTED]
  const passwordFields = [
    'change_password',
    'forgot_password',
    'password_reset_requested'
  ];
  if (passwordFields.includes(field)) return '[PROTECTED]';
  // Legacy bcrypt hashes and [REDACTED] marker
  if (
    typeof val === 'string' &&
    (val.startsWith('$2b$') || val === '[REDACTED]')
  )
    return '[PROTECTED]';
  // Boolean: Account Status
  if (field === 'is_active' || field === 'delete_user') {
    if (val === 'true' || val === true) return 'Active';
    if (val === 'false' || val === false) return 'Inactive';
  }
  // Boolean: Account Verification
  if (field === 'is_verified') {
    if (val === 'true' || val === true) return 'Verified';
    if (val === 'false' || val === false) return 'Pending First Login';
  }
  // Boolean: Password Status
  if (field === 'is_expired') {
    if (val === 'true' || val === true) return 'Expired';
    if (val === 'false' || val === false) return 'Valid';
  }
  // Permission Level
  if (field === 'level') {
    if (String(val) === '1') return 'Level 1';
    if (String(val) === '2') return 'Level 2';
    if (String(val) === '3') return 'Level 3';
  }
  return val;
};

// Report types whose full event timeline is loaded client-side by a dedicated
// loadXxxTimeline handler and rendered in one shot (no server paging). They must
// be excluded from the server pagination refetch effect AND from the paged
// footer — otherwise a >1-page footer both mispaginates the un-sliced events and
// (on page click) re-dispatches getAllReports with an unsupported log_type,
// wiping the loaded trail.
const CLIENT_TIMELINE_REPORT_TYPES = [
  'material_receipt_audit',
  'wip_label_audit',
  'miscellaneous_label_audit',
  'move_material_audit',
  'mrr_audit',
  'lc_material_verification_audit',
  'product_verification_audit'
];

const ViewAuditTrailsPage = () => {
  const dispatch = useDispatch();
  const { allMaterials } = useSelector((state) => state.stocks);
  const [form] = Form.useForm();
  const [dateRange, setDateRange] = useState([moment(), moment()]);
  const [reportData, setReportData] = useState([]);
  const [failedLogData, setFailedLogData] = useState([]);
  const [type, setType] = useState();
  const [showTable, setShowTable] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pagination, setPagination] = useState({});
  const [fromdate, setFromdate] = useState();
  const [todate, setTodate] = useState();
  const [reporttype, setReporttype] = useState();
  const [search, setSearch] = useState('');
  const [batches, setBatches] = useState([]);
  const [subType, setSubType] = useState('');
  const [poNumbers, setPoNumbers] = useState([]);
  const [pOINV, setPOINV] = useState('');
  const [rooms, setRooms] = useState([]);
  const [roomID, setRoomID] = useState('');
  const [equipmentsList, setEquipmentsList] = useState([]);
  const [stage1Batches, setStage1Batches] = useState([]);
  const [stage1Batch, setStage1Batch] = useState('');
  const [stage1Search, setStage1Search] = useState('');
  const stage1DebounceRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [selectedBatchIds, setSelectedBatchIds] = useState([]);
  const [audit_receipt, setAuditReceipt] = useState(null);
  const [candidate_modal_open, setCandidateModalOpen] = useState(false);
  const [candidate_rows, setCandidateRows] = useState([]);
  // Material Receipt date-range flow: pick up to 5 receipts → one combined PDF.
  const [receipt_range_modal_open, setReceiptRangeModalOpen] = useState(false);
  const [receipt_range_rows, setReceiptRangeRows] = useState([]);
  const [receipt_range_selected, setReceiptRangeSelected] = useState([]);
  const [receipt_range_truncated, setReceiptRangeTruncated] = useState(false);
  const [receipt_range_page, setReceiptRangePage] = useState(1);
  const [combinedPdfLoading, setCombinedPdfLoading] = useState(false);
  const RECEIPT_COMBINE_MAX = 5;
  const RECEIPT_PAGE_SIZE = 5;
  const [movePrintEvents, setMovePrintEvents] = useState([]);
  const [mrrPrintEvents, setMrrPrintEvents] = useState([]);
  const [materialPrintEvents, setMaterialPrintEvents] = useState([]);
  // LC Material Verification: process/sub-process combinations for the entered
  // product batch, shown as an on-page dropdown (not a popup). Each option is one
  // line-clearance dispensing request.
  const [lcProcessOptions, setLcProcessOptions] = useState([]);
  const [lcProcessLoading, setLcProcessLoading] = useState(false);
  const lcBatchDebounceRef = useRef(null);
  // Product Verification: process/sub-process combinations for the entered
  // packing batch, shown as an on-page dropdown. Each option carries a composite
  // selector (anchor + process + previous batch).
  const [pvProcessOptions, setPvProcessOptions] = useState([]);
  const [pvProcessLoading, setPvProcessLoading] = useState(false);
  // True only after a non-empty batch search settled with zero matches — drives
  // a quiet inline placeholder instead of a disruptive toast while typing.
  const [pvNoResults, setPvNoResults] = useState(false);
  const pvBatchDebounceRef = useRef(null);
  // const [code, setCode] = useState('');

  useEffect(() => {
    handleGetAllMaterialsList();
    handleGetAllPONumbers();
    handleGetAllContainerRooms();
    handleGetAllEquipmentsList();
    handleGetAllDispenses();
  }, [search, subType]);

  useEffect(() => {
    dispatch(getStage1Batches({ search: stage1Search })).then((response) => {
      if (response?.payload?.success) {
        setStage1Batches(response?.payload?.data || []);
      }
    });
  }, [stage1Search]);

  const onStage1SearchDebounced = (value) => {
    if (stage1DebounceRef.current) clearTimeout(stage1DebounceRef.current);
    stage1DebounceRef.current = setTimeout(() => {
      setStage1Search(value);
    }, 400);
  };

  // LC Material Verification — when the product batch number changes, (re)load
  // its process/sub-process combinations into the on-page dropdown. Clears any
  // previous selection so a stale combo can never be submitted. Debounced so we
  // don't fire a request on every keystroke. If exactly one combination exists
  // it is auto-selected to save a click.
  const onLcBatchChange = (value) => {
    form.setFieldsValue({ lc_process_combo: undefined });
    setLcProcessOptions([]);
    const batch = (value || '').trim();
    if (lcBatchDebounceRef.current) clearTimeout(lcBatchDebounceRef.current);
    if (!batch) {
      setLcProcessLoading(false);
      return;
    }
    setLcProcessLoading(true);
    lcBatchDebounceRef.current = setTimeout(() => {
      dispatch(fetchLcMatVerCandidates({ product_batch_number: batch }))
        .then((response) => {
          // Latest-batch guard (GxP wrong-record safety): if the user has since
          // changed the batch field, discard this (possibly out-of-order)
          // response so we never show / auto-select options for the wrong batch.
          const current = (
            form.getFieldValue('lc_product_batch_number') || ''
          ).trim();
          if (current !== batch) return;
          const list = response?.payload?.success
            ? response.payload.data || []
            : [];
          setLcProcessOptions(list);
          if (list.length === 1) {
            form.setFieldsValue({ lc_process_combo: list[0].id });
          } else if (list.length === 0) {
            message.error(
              'No line-clearance requests found for that product batch number.'
            );
          }
        })
        .finally(() => {
          const current = (
            form.getFieldValue('lc_product_batch_number') || ''
          ).trim();
          if (current === batch) setLcProcessLoading(false);
        });
    }, 500);
  };

  // Human label for a process/sub-process option in the LC dropdown.
  const lcProcessLabel = (o) => {
    const proc = o.process && o.process !== 'N/A' ? o.process : 'Process —';
    const sub =
      o.sub_process && o.sub_process !== 'N/A' ? ` › ${o.sub_process}` : '';
    const status = o.material_verify_status
      ? ` (${o.material_verify_status})`
      : '';
    return `${proc}${sub}${status}`;
  };

  // Product Verification — load process/previous-batch combinations for the
  // entered packing batch into the on-page dropdown. Mirrors onLcBatchChange
  // (debounced, latest-batch guard, auto-select single, clear toast if none).
  const onPvBatchChange = (value) => {
    form.setFieldsValue({ pv_process_combo: undefined });
    setPvProcessOptions([]);
    setPvNoResults(false);
    const batch = (value || '').trim();
    if (pvBatchDebounceRef.current) clearTimeout(pvBatchDebounceRef.current);
    if (!batch) {
      setPvProcessLoading(false);
      return;
    }
    setPvProcessLoading(true);
    pvBatchDebounceRef.current = setTimeout(() => {
      dispatch(fetchProdVerCandidates({ batch_number: batch }))
        .then((response) => {
          const current = (form.getFieldValue('pv_batch_number') || '').trim();
          if (current !== batch) return;
          const list = response?.payload?.success
            ? response.payload.data || []
            : [];
          setPvProcessOptions(list);
          // No toast here — this runs on every debounced keystroke, so a partial
          // batch would flash a misleading error. Empty results are shown quietly
          // via the dropdown placeholder (pvNoResults) once typing settles.
          setPvNoResults(list.length === 0);
          if (list.length === 1) {
            form.setFieldsValue({ pv_process_combo: list[0].key });
          }
        })
        .finally(() => {
          const current = (form.getFieldValue('pv_batch_number') || '').trim();
          if (current === batch) setPvProcessLoading(false);
        });
    }, 500);
  };

  // Label for a Product Verification lineage entry:
  //   "<consuming stage> — <batch at stage> · from <previous stage> (<previous batch>)"
  // Each part is guarded so a missing value reads as '—' rather than "undefined".
  const pvProcessLabel = (o) => {
    const stage =
      o.verified_at_stage && o.verified_at_stage !== 'N/A'
        ? o.verified_at_stage
        : '—';
    const cur =
      o.current_batch && o.current_batch !== 'N/A' ? o.current_batch : '—';
    const prevStage =
      o.previous_stage && o.previous_stage !== 'N/A' ? o.previous_stage : '—';
    const prevBatch =
      o.previous_batch_number && o.previous_batch_number !== 'N/A'
        ? o.previous_batch_number
        : '—';
    return `${stage} — ${cur} · from ${prevStage} (${prevBatch})`;
  };

  // Render a label with a small info (i) button whose tooltip guides the user.
  // Used by the Product Verification fields and the Login/Logout "Event" column.
  const labelWithInfo = (text, tip) => (
    <span>
      {text}{' '}
      <Tooltip title={tip}>
        <InfoCircleOutlined
          aria-label="More information"
          style={{ color: '#1a3c5e', cursor: 'help' }}
        />
      </Tooltip>
    </span>
  );

  // Load the Product Verification timeline for a selected candidate (carries the
  // composite selector: anchor + process_id + previous_batch_number).
  const loadProdVerTimeline = (candidate) => {
    setReporttype('product_verification_audit');
    setPage(1);
    setLoading(true);
    const selector = {
      process_id: candidate.process_id,
      previous_batch_number: candidate.previous_batch_number
    };
    if (candidate.lc_bmr_eqp_id) {
      selector.lc_bmr_eqp_id = candidate.lc_bmr_eqp_id;
    } else {
      selector.packing_dispensing_request_id =
        candidate.packing_dispensing_request_id;
    }
    dispatch(fetchProdVerTimeline(selector))
      .then((response) => {
        if (response?.payload?.success) {
          const data = response.payload.data || {};
          setAuditReceipt(data.header || null);
          setReportData(data.events || []);
          setType('product_verification_audit');
          setShowTable(true);
          setPagination({
            total_records: (data.events || []).length,
            current_page: 1,
            per_page: (data.events || []).length || 1,
            total_page: 1
          });
        } else {
          message.error(
            response?.payload?.message ||
              'Failed to load product verification audit trail.'
          );
        }
      })
      .finally(() => setLoading(false));
  };

  const user = LocalStorage.getItem('Gravity_user');
  const authToken = user?.token;

  const handleGetAllMaterialsList = () => {
    let payload = { search };
    dispatch(getAllMaterialslist(payload));
  };

  const handleChangeBatch = (selectedValues) => {
    setSelectedBatchIds(selectedValues); // selectedValues is already an array of IDs
  };

  const handleGetAllDispenses = () => {
    let payload = { search };

    dispatch(getAllDispenses(payload)).then(function (response) {
      if (response?.payload?.success) {
        console.log(response?.payload?.data);
        setDataSource(response?.payload?.data);
      }
    });
  };

  const handleGetAllEquipmentsList = () => {
    // Dedicated audit-only source: distinct equipment ids that actually have
    // equipment logs (from equipment_log_books), not the shared equipment_models
    // list. This shows exactly what the report can cover — including ids with
    // logs but no master row (e.g. PRE0410) — already de-duplicated, and leaves
    // the shared get_equipment_models (Move Materials / Generate Labels) untouched.
    const payload = { search };
    dispatch(getEqpLogEquipmentIds(payload)).then(function (response) {
      if (response?.payload?.success) {
        setEquipmentsList(response?.payload?.data || []);
      }
    });
  };

  const handleGetAllContainerRooms = () => {
    dispatch(getAllContainerRooms()).then((res) => {
      if (res?.payload?.success) {
        setRooms(res?.payload?.data);
      }
    });
  };

  const handleGetAllPONumbers = () => {
    let payload = { type: subType, search };
    dispatch(getPoNumbers(payload)).then((res) => {
      if (res?.payload?.success) {
        setPoNumbers(res?.payload?.data);
      }
    });
  };

  const loadMaterialReceiptAuditByDocId = (document_id) => {
    dispatch(fetchMaterialReceiptAuditTrail({ document_id })).then(
      (response) => {
        if (response?.payload?.success) {
          const data = response.payload.data;
          setAuditReceipt(data.receipt);
          setReportData(data.events || []);
          // Label print/reprint events go into a separate sub-table below the
          // main timeline, mirroring how Move Material and MRR audit reports
          // surface their print events.
          setMaterialPrintEvents(data.print_events || []);
          setShowTable(true);
          setPagination({
            total_records: (data.events || []).length,
            current_page: 1,
            per_page: (data.events || []).length || 1,
            total_page: 1
          });
        } else {
          message.error(
            response?.payload?.message ||
              'Failed to load audit trail for this receipt.'
          );
        }
      }
    );
  };

  // Generate one combined PDF for the receipts ticked in the date-range picker.
  const generateCombinedReceiptPdf = () => {
    const ids = receipt_range_selected;
    if (!ids.length) {
      message.error('Select at least one receipt.');
      return;
    }
    if (ids.length > RECEIPT_COMBINE_MAX) {
      message.error(`You can combine at most ${RECEIPT_COMBINE_MAX} receipts.`);
      return;
    }
    setCombinedPdfLoading(true);
    dispatch(
      downloadMaterialReceiptCombinedPdf({ document_ids: ids.join(',') })
    )
      .then((response) => {
        if (response?.payload?.success) {
          window.open(
            `${process.env.REACT_APP_STORAGE_URL}${response.payload.data
              .split('/')
              .pop()}`,
            '_blank'
          );
          message.success('Combined audit trail PDF generated');
          setReceiptRangeModalOpen(false);
          setReceiptRangeSelected([]);
        } else {
          message.error(
            response?.payload?.message || 'Failed to generate combined PDF.'
          );
        }
      })
      .finally(() => setCombinedPdfLoading(false));
  };

  const loadWipLabelTimelineById = (prod_dispenses_id) => {
    dispatch(fetchWipLabelTimeline({ prod_dispenses_id })).then((response) => {
      if (response?.payload?.success) {
        const data = response.payload;
        // Stash the id on the header so the Export PDF button can use it
        // without reading from form fields (the picker flow doesn't fill form).
        setAuditReceipt({
          ...(data.header || {}),
          _prod_dispenses_id: prod_dispenses_id
        });
        setReportData(data.events || []);
        setShowTable(true);
        setPagination({
          total_records: (data.events || []).length,
          current_page: 1,
          per_page: (data.events || []).length || 1,
          total_page: 1
        });
      } else {
        message.error(
          response?.payload?.message ||
            'Failed to load audit trail for this labelling session.'
        );
      }
    });
  };

  const loadMscLabelTimelineById = (id) => {
    dispatch(fetchMscLabelTimeline({ id })).then((response) => {
      if (response?.payload?.success) {
        const data = response.payload;
        setAuditReceipt({ ...(data.header || {}), _id: id });
        setReportData(data.events || []);
        setShowTable(true);
        setPagination({
          total_records: (data.events || []).length,
          current_page: 1,
          per_page: (data.events || []).length || 1,
          total_page: 1
        });
      } else {
        message.error(
          response?.payload?.message ||
            'Failed to load audit trail for this miscellaneous container.'
        );
      }
    });
  };

  const loadMoveMaterialTimeline = (candidate) => {
    setReporttype('move_material_audit');
    setPage(1);
    setLoading(true);
    dispatch(
      fetchMoveMaterialAuditTrail({
        batch_number: candidate.number,
        batch_kind: candidate.kind
      })
    )
      .then((response) => {
        if (response?.payload?.success) {
          const data = response.payload.data || {};
          setAuditReceipt(data.batch || null);
          setReportData(data.events || []);
          setMovePrintEvents(data.print_events || []);
          setType('move_material_audit');
          setShowTable(true);
          setPagination({
            total_records: (data.events || []).length,
            current_page: 1,
            per_page: (data.events || []).length || 1,
            total_page: 1
          });
        } else {
          message.error(
            response?.payload?.message ||
              'Failed to load Move Material audit trail.'
          );
        }
      })
      .finally(() => setLoading(false));
  };

  const loadMrrTimeline = (candidate) => {
    setReporttype('mrr_audit');
    setPage(1);
    setLoading(true);
    const selector =
      candidate.MRR_number && candidate.MRR_number !== 'N/A'
        ? { mrr_number: candidate.MRR_number }
        : { product_batch_number: candidate.product_batch_number };
    dispatch(fetchMrrAuditTrail(selector))
      .then((response) => {
        if (response?.payload?.success) {
          const data = response.payload.data || {};
          setAuditReceipt(
            data.batch ? { ...data.batch, _selector: selector } : null
          );
          setReportData(data.events || []);
          setMrrPrintEvents(data.print_events || []);
          setType('mrr_audit');
          setShowTable(true);
          setPagination({
            total_records: (data.events || []).length,
            current_page: 1,
            per_page: (data.events || []).length || 1,
            total_page: 1
          });
        } else {
          message.error(
            response?.payload?.message || 'Failed to load MRR audit trail.'
          );
        }
      })
      .finally(() => setLoading(false));
  };

  const loadLcMatVerTimeline = (dispensing_request_id) => {
    setReporttype('lc_material_verification_audit');
    setPage(1);
    setLoading(true);
    dispatch(fetchLcMatVerTimeline({ dispensing_request_id }))
      .then((response) => {
        if (response?.payload?.success) {
          const data = response.payload.data || {};
          setAuditReceipt(data.header || null);
          setReportData(data.events || []);
          setType('lc_material_verification_audit');
          setShowTable(true);
          setPagination({
            total_records: (data.events || []).length,
            current_page: 1,
            per_page: (data.events || []).length || 1,
            total_page: 1
          });
        } else {
          message.error(
            response?.payload?.message ||
              'Failed to load material verification audit trail.'
          );
        }
      })
      .finally(() => setLoading(false));
  };

  // Reset the report selection back to its default state. Called after a
  // download settles so the form is ready for the next selection.
  const resetSelection = () => {
    form.resetFields();
    // selectedOption drives the conditional fields (Select Room, date range, etc.),
    // so it must be cleared to hide them after a download.
    setSelectedOption('');
    setType(undefined);
    setReporttype(undefined);
    setSubType('');
    setRoomID('');
    setPOINV('');
    setBatches([]);
    setStage1Batch('');
    setSelectedBatchIds([]);
    setDateRange([moment(), moment()]);
    setFromdate(undefined);
    setTodate(undefined);
    setShowTable(false);
    setReceiptRangeModalOpen(false);
    setReceiptRangeRows([]);
    setReceiptRangeSelected([]);
    setReceiptRangeTruncated(false);
    setReceiptRangePage(1);
    setLcProcessOptions([]);
    setLcProcessLoading(false);
    setPvProcessOptions([]);
    setPvProcessLoading(false);
    setPvNoResults(false);
  };

  const onFinish = (values) => {
    setType(values.report);

    if (values.report === 'material_receipt_audit') {
      setReporttype(values.report);
      setPage(1);
      setAuditReceipt(null);
      setMaterialPrintEvents([]);
      const invoice_number = (values.invoice_number || '').trim();
      const from =
        values.receipt_range && values.receipt_range[0]
          ? moment(
              values.receipt_range[0]._d || values.receipt_range[0]
            ).format('YYYY-MM-DD')
          : '';
      const to =
        values.receipt_range && values.receipt_range[1]
          ? moment(
              values.receipt_range[1]._d || values.receipt_range[1]
            ).format('YYYY-MM-DD')
          : '';

      // Date-range flow: list receipts in the window → pick up to 5 →
      // generate a single combined PDF. Invoice number takes precedence.
      if (!invoice_number && from && to) {
        setReceiptRangeSelected([]);
        setReceiptRangeRows([]);
        setReceiptRangeTruncated(false);
        setReceiptRangePage(1);
        dispatch(
          fetchMaterialReceiptRangeCandidates({ from_date: from, to_date: to })
        ).then((response) => {
          if (response?.payload?.success) {
            const candidates = response.payload.data || [];
            if (candidates.length === 0) {
              message.error('No receipts found in the selected date range.');
              return;
            }
            setReceiptRangeRows(candidates);
            setReceiptRangeTruncated(!!response.payload.truncated);
            setReceiptRangeModalOpen(true);
          } else {
            message.error(
              response?.payload?.message ||
                'No receipts found in the selected date range.'
            );
          }
        });
        return;
      }

      if (!invoice_number) {
        message.error(
          'Enter an Invoice Number, or pick both From and To dates.'
        );
        return;
      }

      dispatch(fetchMaterialReceiptAuditCandidates({ invoice_number })).then(
        (response) => {
          if (response?.payload?.success) {
            const candidates = response.payload.data || [];
            if (candidates.length === 0) {
              message.error(
                'No receipt found for the provided invoice number.'
              );
            } else if (candidates.length === 1) {
              loadMaterialReceiptAuditByDocId(candidates[0].id);
            } else {
              setCandidateRows(candidates);
              setCandidateModalOpen(true);
            }
          } else {
            message.error(
              response?.payload?.message ||
                'No receipt found for the provided invoice number.'
            );
          }
        }
      );
      return;
    }

    if (values.report === 'wip_label_audit') {
      setReporttype(values.report);
      setPage(1);
      setAuditReceipt(null);
      const batch_no = (values.batch_no || '').trim();
      dispatch(fetchWipLabelCandidates({ batch_no })).then((response) => {
        if (response?.payload?.success) {
          const candidates = response.payload.data || [];
          if (candidates.length === 0) {
            message.error('No labelling sessions found for this batch number.');
          } else if (candidates.length === 1) {
            loadWipLabelTimelineById(candidates[0].id);
          } else {
            setCandidateRows(candidates);
            setCandidateModalOpen(true);
          }
        } else {
          message.error(
            response?.payload?.message ||
              'No labelling sessions found for this batch number.'
          );
        }
      });
      return;
    }

    if (values.report === 'move_material_audit') {
      setReporttype(values.report);
      setPage(1);
      setAuditReceipt(null);
      setMovePrintEvents([]);
      const batch_number = (values.batch_number || '').trim();
      dispatch(fetchMoveMaterialAuditCandidates({ batch_number })).then(
        (response) => {
          if (response?.payload?.success) {
            const candidates = response.payload.data || [];
            if (candidates.length === 0) {
              message.error('No batch found for that number.');
            } else if (candidates.length === 1) {
              loadMoveMaterialTimeline(candidates[0]);
            } else {
              setCandidateRows(candidates);
              setCandidateModalOpen(true);
            }
          } else {
            message.error(
              response?.payload?.message || 'No batch found for that number.'
            );
          }
        }
      );
      return;
    }

    if (values.report === 'mrr_audit') {
      setReporttype(values.report);
      setPage(1);
      setAuditReceipt(null);
      setMrrPrintEvents([]);
      const mrr_number = (values.mrr_number || '').trim();
      const product_batch_number = (
        values.mrr_product_batch_number || ''
      ).trim();
      if (!mrr_number && !product_batch_number) {
        message.error(
          'Enter MRR Number or Product Batch Number (at least one is required).'
        );
        return;
      }
      const payload = mrr_number ? { mrr_number } : { product_batch_number };
      dispatch(fetchMrrAuditCandidates(payload)).then((response) => {
        if (response?.payload?.success) {
          const candidates = response.payload.data || [];
          if (candidates.length === 0) {
            message.error('No MRR found for the provided search.');
          } else if (candidates.length === 1) {
            loadMrrTimeline(candidates[0]);
          } else if (mrr_number) {
            // Multiple partial matches — show picker.
            setCandidateRows(candidates);
            setCandidateModalOpen(true);
          } else {
            // Multiple MRRs for one batch — aggregate all into a single timeline.
            loadMrrTimeline({
              product_batch_number,
              MRR_number: null
            });
          }
        } else {
          message.error(
            response?.payload?.message ||
              'No MRR found for the provided search.'
          );
        }
      });
      return;
    }

    if (values.report === 'lc_material_verification_audit') {
      setReporttype(values.report);
      setPage(1);
      setAuditReceipt(null);
      // Both the batch number and the process/sub-process dropdown carry
      // `required` rules, so antd only reaches onFinish once a combination is
      // selected. The dropdown value IS the dispensing_request_id to report on.
      loadLcMatVerTimeline(values.lc_process_combo);
      return;
    }

    if (values.report === 'product_verification_audit') {
      setReporttype(values.report);
      setPage(1);
      setAuditReceipt(null);
      // The dropdown value is a composite `key`; resolve the full candidate
      // (carrying the anchor + process + previous batch) and load its timeline.
      const candidate = pvProcessOptions.find(
        (o) => o.key === values.pv_process_combo
      );
      if (!candidate) {
        message.error('Select a process / previous batch.');
        return;
      }
      loadProdVerTimeline(candidate);
      return;
    }

    if (values.report === 'miscellaneous_label_audit') {
      setReporttype(values.report);
      setPage(1);
      setAuditReceipt(null);
      const msc_id = (values.msc_id || '').trim();
      const from =
        values.msc_range && values.msc_range[0]
          ? moment(values.msc_range[0]._d || values.msc_range[0]).format(
              'YYYY-MM-DD'
            )
          : '';
      const to =
        values.msc_range && values.msc_range[1]
          ? moment(values.msc_range[1]._d || values.msc_range[1]).format(
              'YYYY-MM-DD'
            )
          : '';
      if (!msc_id && (!from || !to)) {
        message.error(
          'Enter either a Container ID, or both From and To dates.'
        );
        return;
      }
      const payload = msc_id ? { msc_id } : { from, to };
      dispatch(fetchMscLabelCandidates(payload)).then((response) => {
        if (response?.payload?.success) {
          const candidates = response.payload.data || [];
          if (candidates.length === 0) {
            message.error('No miscellaneous containers found.');
          } else if (candidates.length === 1) {
            loadMscLabelTimelineById(candidates[0].id);
          } else {
            setCandidateRows(candidates);
            setCandidateModalOpen(true);
          }
        } else {
          message.error(
            response?.payload?.message || 'No miscellaneous containers found.'
          );
        }
      });
      return;
    }

    if (
      values.report === 'EBMR_batch_lifecycle' ||
      values.report === 'EBMR_Audit_Logs'
    ) {
      const idsParam = `[${selectedBatchIds.join(',')}]`;
      const baseUrl = `${process.env.REACT_APP_API_URL}/audit_log/audit_log_download`;
      const url = `${baseUrl}?log_type=${values.report}&dispensing_request_id=${idsParam}`;
      setLoading(true);
      fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${authToken}`,
          'X-Session-Token': user?.session_token || ''
        }
      })
        .then((response) => response.json())
        .then((data) => {
          if (data?.success) {
            const fileUrl = `${process.env.REACT_APP_STORAGE_URL}${data?.data
              .split('/')
              .pop()}`;
            const a = document.createElement('a');
            a.href = fileUrl;
            a.target = '_blank';
            a.rel = 'noopener noreferrer';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            message.success('Report downloaded successfully');
            form.resetFields();
            setSelectedBatchIds([]);
          } else {
            message.error(data?.message || 'Failed to generate report');
          }
        })
        .catch(() => {
          message.error('Failed to generate report. Please try again.');
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      const fromDate = values.fromDate
        ? `${moment(values.fromDate[0]._d).format('YYYY-MM-DD')}`
        : '';
      const toDate = values.fromDate
        ? `${moment(values.fromDate[1]._d).format('YYYY-MM-DD')}`
        : '';
      setFromdate(fromDate);
      setTodate(toDate);
      setReporttype(values.report);
      console.log(type, 'type');

      setPage(1);
      const payload =
        values.report === 'equipment_logs'
          ? {
              log_type: 'equipment_logs',
              equipment_id: roomID,
              // Optional date range — filtered by activity start_date on the
              // backend. Empty when the picker is untouched, so the report
              // returns all logs for the equipment (unchanged behavior).
              from_date: values.equipment_date_range?.[0]
                ? moment(
                    values.equipment_date_range[0]._d ||
                      values.equipment_date_range[0]
                  ).format('YYYY-MM-DD')
                : '',
              to_date: values.equipment_date_range?.[1]
                ? moment(
                    values.equipment_date_range[1]._d ||
                      values.equipment_date_range[1]
                  ).format('YYYY-MM-DD')
                : ''
            }
          : values.report === 'product_batchwise_equipment_log'
          ? {
              log_type: 'product_batchwise_equipment_log',
              product_batch: stage1Batch
            }
          : values.report === 'wip_prod_labels' ||
            values.report === 'outward_logs' ||
            values.report === 'inward_logs'
          ? {
              log_type:
                values.report === 'wip_prod_labels'
                  ? 'wip_prod_labels'
                  : values.report === 'outward_logs'
                  ? 'prod_label_outward'
                  : 'prod_label_inward',
              from_date: fromDate,
              to_date: toDate,
              prod_room_id: roomID
            }
          : type === 'inv_tracker_status' && subType !== 'date_range'
          ? subType === 'invoice_num'
            ? {
                log_type: values.report,
                invoice_no: pOINV,
                page: 1,
                per_page: pageSize
              }
            : {
                log_type: values.report,
                po_no: pOINV,
                page: 1,
                per_page: pageSize
              }
          : {
              from_date: fromDate,
              to_date: toDate,
              log_type: values.report,
              batch_details_id:
                values.inhouse_batch_id !== undefined
                  ? values.inhouse_batch_id
                  : '',
              page: 1,
              per_page: pageSize
            };
      values.report === 'wip_prod_labels' ||
      values.report === 'outward_logs' ||
      values.report === 'inward_logs' ||
      values.report === 'equipment_logs' ||
      values.report === 'product_batchwise_equipment_log' ||
      values.report === 'EBMR_login_logout' ||
      values.report === 'ebmr_event_log'
        ? (setLoading(true),
          dispatch(DownloadAuditReport(payload))
            .then((response) => {
              console.log(response);
              if (response?.payload?.success) {
                const filename = response?.payload?.data?.split('/').pop();
                if (values.report === 'product_batchwise_equipment_log') {
                  const downloadUrl = `${process.env.REACT_APP_STORAGE_URL}${filename}`;
                  fetch(downloadUrl, {
                    method: 'GET',
                    headers: { Authorization: `Bearer ${authToken}` }
                  })
                    .then((r) => r.blob())
                    .then((blob) => {
                      const blobUrl = window.URL.createObjectURL(blob);
                      const a = document.createElement('a');
                      a.href = blobUrl;
                      a.setAttribute('download', filename);
                      document.body.appendChild(a);
                      a.click();
                      a.remove();
                      window.URL.revokeObjectURL(blobUrl);
                      message.success('Report Downloaded successfully');
                    })
                    .catch(() => {
                      message.error('Failed to download report');
                    });
                } else {
                  // window.open(response?.payload?.data, '_blank');
                  window.open(
                    `${process.env.REACT_APP_STORAGE_URL}${filename}`,
                    '_blank'
                  );
                  message.success('Report Downloaded successfully');
                }
              } else if (response?.payload?.message) {
                message.error(response.payload.message);
              }
            })
            .catch(() => {
              message.error('Failed to generate report. Please try again.');
            })
            .finally(() => {
              setLoading(false);
              resetSelection();
            }))
        : type == 'failed_login'
        ? dispatch(getFailedLoginReports(payload)).then((response) => {
            if (response?.payload?.success) {
              message.success(response?.payload?.message);
              setShowTable(true);
              setFailedLogData(response?.payload?.data);
              setPagination(response?.payload?.pagination);
            }
          })
        : dispatch(getAllReports(payload)).then((response) => {
            if (response?.payload?.success) {
              message.success(response?.payload?.message);
              setShowTable(true);
              setReportData(response?.payload?.data);
              setPagination(response?.payload?.pagination);
            }
          });
    }
  };

  console.log(batches);
  const downloadReport = () => {
    setLoading(true);
    const fromDate = fromdate || '';
    const toDate = todate || '';
    const reportType = reporttype || '';

    const payload =
      type === 'inv_tracker_status' && subType !== 'date_range'
        ? subType === 'invoice_num'
          ? {
              log_type: reportType,
              invoice_no: pOINV
            }
          : {
              log_type: reportType,
              po_no: pOINV
            }
        : batches[0]?.id
        ? {
            from_date: fromDate,
            to_date: toDate,
            log_type: reportType,
            batch_details_id: batches[0]?.id
          }
        : {
            from_date: fromDate,
            to_date: toDate,
            log_type: reportType
          };
    //   {
    //   from_date: fromDate,
    //   to_date: toDate,
    //   log_type: reportType,
    //   batch_details_id: batches[0]?.id
    // };
    dispatch(DownloadAuditReport(payload))
      .then((response) => {
        if (response?.payload?.success && response?.payload?.data) {
          window.open(
            `${process.env.REACT_APP_STORAGE_URL}${response.payload.data
              .split('/')
              .pop()}`,
            '_blank'
          );
          message.success('Report downloaded successfully');
        } else {
          message.error(
            response?.payload?.message ||
              'Failed to generate report. Please try again.'
          );
        }
      })
      .catch(() => {
        message.error('Failed to generate report. Please try again.');
      })
      .finally(() => {
        setLoading(false);
        resetSelection();
      });
    // const user = LocalStorage.getItem('Gravity_user');

    // const authToken = user?.token;
    // fetch(
    //   `${process.env.REACT_APP_API_URL}/audit_log/audit_log_download?from_date=${fromDate}&to_date=${toDate}&log_type=${reportType}`,
    //   {
    //     method: 'GET'
    // headers: {
    //   'Content-Type': 'application/csv',
    //   Authorization: `Bearer ${authToken}`
    // }
    //   }
    // ).then((response) =>
    // response.blob())
    // .then((blob) =>
    // {
    //   console.log(response?.url);
    //   window.open(response?.url, '_blank');
    // console.log(blob);
    // const url = window.URL.createObjectURL(new Blob([blob]));
    // const link = document.createElement('a');
    // link.href = url;
    // link.setAttribute('download', `Report.csv`);
    // document.body.appendChild(link);
    // link.click();
    // link.parentNode.removeChild(link);
    // message.success('Report Downloaded successfully');
    // form.resetFields();
    // setDownloadReports(false);
    // }
    // );
  };
  useEffect(() => {
    // Pagination effect — only runs once a report has actually been selected.
    // Prevents an invalid call (log_type: undefined) on initial page load.
    // Client-loaded timeline reports are fetched whole by their loadXxxTimeline
    // handlers and are not server-paged; re-dispatching here sent an unsupported
    // log_type and wiped the loaded events, so skip them entirely.
    if (!type || CLIENT_TIMELINE_REPORT_TYPES.includes(type)) return;
    const payload = {
      page,
      per_page: pageSize,
      log_type: type,
      from_date: fromdate,
      to_date: todate
    };
    type == 'failed_login'
      ? dispatch(getFailedLoginReports(payload)).then((response) => {
          if (response?.payload?.success) {
            message.success(response?.payload?.message);
            setShowTable(true);
            setFailedLogData(response?.payload?.data);
            setPagination(response?.payload?.pagination);
          }
        })
      : dispatch(getAllReports(payload)).then((response) => {
          if (response?.payload?.success) {
            message.success(response?.payload?.message);
            setShowTable(true);
            setReportData(response?.payload?.data);
            setPagination(response?.payload?.pagination);
          }
        });
  }, [page, pageSize]);

  const matstatuscolumns = [
    {
      title: 'Material ID',
      dataIndex: 'material_id',
      key: 'material_id',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.material?.code || 'NA';
      }
    },
    {
      title: 'Material Status',
      dataIndex: 'material_status',
      key: 'material_status',
      ellipsis: true,
      width: '100px',
      render: (text) => {
        return text || 'NA';
      }
    },
    {
      title: 'Changed By',
      dataIndex: 'user_id',
      key: 'user_id',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.User?.employee_id || 'NA';
      }
    },
    {
      title: 'Changed On',
      dataIndex: 'created_at',
      key: 'created_at',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return (
          moment(record?.updated_date).format('DD MMM YYYY (hh:mm A)') || 'NA'
        );
      }
    }
  ];
  const venstatuscolumns = [
    {
      title: 'Material ID',
      dataIndex: 'material_id',
      key: 'material_id',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.material?.code || 'NA';
      }
    },
    {
      title: 'Vendor Status',
      dataIndex: 'vendor_status',
      key: 'vendor_status',
      ellipsis: true,
      width: '100px',
      render: (text) => {
        return text || 'NA';
      }
    },
    {
      title: 'Changed By',
      dataIndex: 'user_id',
      key: 'user_id',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.User?.employee_id || 'NA';
      }
    },
    {
      title: 'Changed On',
      dataIndex: 'created_at',
      key: 'created_at',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return (
          moment(record?.updated_date).format('DD MMM YYYY (hh:mm A)') || 'NA'
        );
      }
    }
  ];

  const SamplingCreationcolumns = [
    {
      title: 'Warehouse Container',
      dataIndex: 'container',
      key: 'container',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.container?.number || 'NA';
      }
    },
    {
      title: 'Material Code',
      dataIndex: 'code',
      key: 'code',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.batch_detail?.material?.code || 'NA';
      }
    },
    {
      title: 'Material Name',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.batch_detail?.material?.name || 'NA';
      }
    },
    {
      title: 'Batch Number',
      dataIndex: 'batch_number',
      key: 'batch_number',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.batch_detail?.inhouse_batch_number || 'NA';
      }
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.original_qty || 'NA';
      }
    },
    {
      title: 'Sampling Date',
      dataIndex: 'sampling_date',
      key: 'sampling_date',
      ellipsis: true,
      width: '100px',
      render: (text) => {
        return moment(text).format('DD MMM YYYY') || 'NA';
      }
    },
    {
      title: 'User ID',
      dataIndex: 'User_id',
      key: 'User_id',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.User?.employee_id || 'NA';
      }
    },
    {
      title: 'Balance ID',
      dataIndex: 'balance_id',
      key: 'balance_id',
      ellipsis: true,
      width: '100px',
      render: (text) => {
        return text || 'NA';
      }
    },
    {
      title: 'AR number',
      dataIndex: 'ar_number',
      key: 'ar_number',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.batch_detail?.ar_number || 'NA';
      }
    },
    {
      /* Which test request this sample belongs to. A batch runs many cycles, and
         the AR alone no longer identifies one - a Resampling cycle carries the
         previous cycle's AR forward, so two rows can show the same AR and belong
         to different requests. NA for rows recorded before cycle tracking. */
      title: 'TRF No',
      dataIndex: 'trf_serial',
      key: 'trf_serial',
      ellipsis: true,
      width: '110px',
      render: (text, record) => {
        const trf = record?.test_request_form;
        return trf?.trf_serial
          ? trf.trf_serial + (trf.cycle_no ? ' (#' + trf.cycle_no + ')' : '')
          : 'NA';
      }
    },
    {
      title: 'Test Requested',
      dataIndex: 'test_requested',
      key: 'test_requested',
      ellipsis: true,
      width: '150px',
      render: (text, record) => {
        const trf = record?.test_request_form;
        return trf?.test_requested || 'NA';
      }
    }
  ];
  const columns = [
    {
      title: 'Field',
      dataIndex: 'field',
      key: 'field',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return text || record?.change_field || 'NA';
      }
    },
    {
      title: 'From',
      dataIndex: 'from',
      key: 'from',
      ellipsis: true,
      width: '100px',
      render: (text) => {
        return text || 'NA';
      }
    },
    {
      title: 'To',
      dataIndex: 'to',
      key: 'to',
      ellipsis: true,
      width: '100px',
      render: (text) => {
        return text || 'NA';
      }
    },
    {
      title: 'Changed By',
      dataIndex: 'change_by',
      key: 'change_by',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return type == 'user_log'
          ? text || 'NA'
          : record?.User?.employee_id || 'NA';
      }
    },
    {
      title: 'Changed At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      width: '100px',
      render: (text) => {
        return moment(text).format('DD MMM YYYY (hh:mm A)') || 'NA';
      }
    }
  ];

  /* The modification log is the generic change-log shape plus the cycle the
     modified sampling row belongs to. Spread rather than duplicated so the
     shared columns stay in one place, and defined here rather than added to
     `columns`, which is the fallback for many other reports. */
  const samplingModificationColumns = [
    ...columns,
    {
      /* Which test request this sample belongs to. A batch runs many cycles, and
         the AR alone no longer identifies one - a Resampling cycle carries the
         previous cycle's AR forward, so two rows can show the same AR and belong
         to different requests. NA for rows recorded before cycle tracking. */
      title: 'TRF No',
      dataIndex: 'trf_serial',
      key: 'trf_serial',
      ellipsis: true,
      width: '110px',
      render: (text, record) => {
        const trf = record?.sampling_history?.test_request_form;
        return trf?.trf_serial
          ? trf.trf_serial + (trf.cycle_no ? ' (#' + trf.cycle_no + ')' : '')
          : 'NA';
      }
    },
    {
      title: 'Test Requested',
      dataIndex: 'test_requested',
      key: 'test_requested',
      ellipsis: true,
      width: '150px',
      render: (text, record) => {
        const trf = record?.sampling_history?.test_request_form;
        return trf?.test_requested || 'NA';
      }
    }
  ];
  // getValue: optional fn(record) => string — use when the displayed value differs from the raw record field
  const getColumnSearchProps = (dataIndex, getValue) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          id={`col-search-${dataIndex}`}
          placeholder="Search"
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: 'block', width: 200 }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => confirm()}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      const cell = getValue ? getValue(record) : record[dataIndex];
      if (cell == null) return false;
      return cell.toString().toLowerCase().includes(value.toLowerCase());
    }
  });

  const logcolumns = [
    {
      title: '#',
      key: 'row_number',
      width: '55px',
      render: (text, record, index) => (page - 1) * pageSize + index + 1
    },
    {
      title: 'Date & Time (IST)',
      dataIndex: 'date',
      key: 'date',
      ellipsis: true,
      width: '200px',
      render: (text) => text || '—',
      filteredValue: filteredInfo['date'] || null,
      ...getColumnSearchProps('date')
    },
    {
      title: 'Employee ID',
      dataIndex: 'employee_id',
      key: 'employee_id',
      ellipsis: true,
      width: '140px',
      render: (text) => text || '—',
      filteredValue: filteredInfo['employee_id'] || null,
      ...getColumnSearchProps('employee_id')
    },
    {
      title: 'Employee Name',
      dataIndex: 'employee_name',
      key: 'employee_name',
      ellipsis: true,
      width: '200px',
      render: (text) => text || '—',
      filteredValue: filteredInfo['employee_name'] || null,
      ...getColumnSearchProps('employee_name')
    }
  ];

  const user_log_columns = [
    {
      title: '#',
      key: 'row_number',
      width: '55px',
      render: (text, record, index) => (page - 1) * pageSize + index + 1
    },
    {
      title: 'Date & Time (IST)',
      dataIndex: 'update_date',
      key: 'update_date',
      ellipsis: true,
      width: '190px',
      render: (text) =>
        text
          ? moment(text).utcOffset('+05:30').format('DD MMM YYYY HH:mm:ss') +
            ' IST'
          : '—'
    },
    {
      title: 'Action',
      dataIndex: 'action_type',
      key: 'action_type',
      ellipsis: true,
      width: '210px',
      render: (text) => USER_LOG_ACTION_LABELS[text] || text || '—',
      filteredValue: filteredInfo['action_type'] || null,
      ...getColumnSearchProps(
        'action_type',
        (r) => USER_LOG_ACTION_LABELS[r.action_type] || r.action_type || ''
      )
    },
    {
      title: 'User Affected',
      dataIndex: 'subject',
      key: 'subject',
      ellipsis: true,
      width: '190px',
      render: (text) => text || '—',
      filteredValue: filteredInfo['subject'] || null,
      ...getColumnSearchProps('subject')
    },
    {
      title: 'Field Changed',
      dataIndex: 'field',
      key: 'field',
      ellipsis: true,
      width: '160px',
      render: (text) => USER_LOG_FIELD_LABELS[text] || text || '—',
      filteredValue: filteredInfo['field'] || null,
      ...getColumnSearchProps(
        'field',
        (r) => USER_LOG_FIELD_LABELS[r.field] || r.field || ''
      )
    },
    {
      title: 'Previous Value',
      dataIndex: 'from',
      key: 'from',
      ellipsis: true,
      width: '160px',
      render: (text, record) => formatUserLogValue(text, record.field),
      filteredValue: filteredInfo['from'] || null,
      ...getColumnSearchProps('from', (r) =>
        formatUserLogValue(r.from, r.field)
      )
    },
    {
      title: 'New Value',
      dataIndex: 'to',
      key: 'to',
      ellipsis: true,
      width: '160px',
      render: (text, record) => formatUserLogValue(text, record.field),
      filteredValue: filteredInfo['to'] || null,
      ...getColumnSearchProps('to', (r) => formatUserLogValue(r.to, r.field))
    },
    {
      title: 'Modified By',
      dataIndex: 'changed_by',
      key: 'changed_by',
      ellipsis: true,
      width: '190px',
      render: (text) => text || '—',
      filteredValue: filteredInfo['changed_by'] || null,
      ...getColumnSearchProps('changed_by')
    }
  ];
  const material_receipt_audit_columns = [
    {
      title: 'Date & Time (IST)',
      dataIndex: 'timestamp',
      key: 'timestamp',
      ellipsis: true,
      width: '200px',
      render: (text) =>
        text
          ? moment(text).utcOffset('+05:30').format('DD MMM YYYY HH:mm:ss') +
            ' IST'
          : 'N/A'
    },
    {
      title: 'Activity',
      dataIndex: 'activity',
      key: 'activity',
      width: '320px',
      render: (text) => text || 'N/A',
      filteredValue: filteredInfo['activity'] || null,
      ...getColumnSearchProps('activity')
    },
    {
      title: 'Performed By',
      dataIndex: 'performed_by',
      key: 'performed_by',
      ellipsis: true,
      width: '220px',
      render: (text) => text || 'N/A',
      filteredValue: filteredInfo['performed_by'] || null,
      ...getColumnSearchProps('performed_by')
    },
    {
      title: 'Details',
      dataIndex: 'details',
      key: 'details',
      width: '420px',
      // pre-line preserves grouped multi-line details (LC Material Verification);
      // a no-op for the other trails whose details are single-line pipe strings.
      render: (text) =>
        text ? <span style={{ whiteSpace: 'pre-line' }}>{text}</span> : 'N/A',
      filteredValue: filteredInfo['details'] || null,
      ...getColumnSearchProps('details')
    }
  ];
  const login_logout_columns = [
    {
      title: '#',
      key: 'row_number',
      width: '55px',
      render: (text, record, index) => (page - 1) * pageSize + index + 1
    },
    {
      title: 'Date & Time (IST)',
      dataIndex: 'date',
      key: 'date',
      ellipsis: true,
      width: '200px',
      render: (text) => text || '—',
      filteredValue: filteredInfo['date'] || null,
      ...getColumnSearchProps('date')
    },
    {
      title: 'Employee ID',
      dataIndex: 'employee_id',
      key: 'employee_id',
      ellipsis: true,
      width: '140px',
      render: (text) => text || '—',
      filteredValue: filteredInfo['employee_id'] || null,
      ...getColumnSearchProps('employee_id')
    },
    {
      title: 'Employee Name',
      dataIndex: 'employee_name',
      key: 'employee_name',
      ellipsis: true,
      width: '200px',
      render: (text) => text || '—',
      filteredValue: filteredInfo['employee_name'] || null,
      ...getColumnSearchProps('employee_name')
    },
    {
      title: labelWithInfo(
        'Event',
        "Login and Logout are successful events; 'Failed Login' is an incorrect-password attempt. All three appear together, newest first."
      ),
      dataIndex: 'type',
      key: 'type',
      ellipsis: true,
      width: '140px',
      render: (text) => text || '—',
      filteredValue: filteredInfo['type'] || null,
      ...getColumnSearchProps('type')
    }
  ];

  const dispensing_deleted_transactions_columns = [
    {
      title: 'Product Batch Number',
      dataIndex: 'product_batch_number',
      key: 'product_batch_number',
      ellipsis: true,
      width: '150px',
      render: (text, record) => {
        return record?.dispensing_request?.product_batch_number;
      }
    },
    {
      title: 'Inhouse Batch Number',
      dataIndex: 'inhouse_batch_number',
      key: 'inhouse_batch_number',
      ellipsis: true,
      width: '150px',
      render: (text, record) => {
        return record?.batch_detail?.inhouse_batch_number;
      }
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      ellipsis: true,
      width: '150px',
      render: (text, record) => {
        return record?.batch_detail?.received_quantity || 'NA';
      }
    },
    // {
    //   title: 'Qty Returned',
    //   dataIndex: 'qty_returned',
    //   key: 'qty_returned',
    //   ellipsis: true,
    //   width: '100px',
    //   render: (text, record) => {
    //     return record?.returned_qty || 'NA';
    //   }
    // },
    {
      title: 'WH Remarks',
      dataIndex: 'wh_remarks',
      key: 'wh_remarks',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.wh_comments || 'NA';
      }
    },
    {
      title: 'Deleted by',
      dataIndex: 'deleted_by',
      key: 'deleted_by',
      ellipsis: true,
      width: '200px',
      render: (text, record) => {
        return record?.qa_approver || 'NA';
      }
    },
    {
      title: 'Deleted at',
      dataIndex: 'deleted_at',
      key: 'deleted_at',
      ellipsis: true,
      width: '20px',
      render: (text, record) => {
        return record?.updatedAt;
      }
    }
  ];

  const ebmr_master_creation_log_columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      width: '200px',
      render: (text, record) => {
        return record?.User?.id;
      }
    },
    {
      title: 'Product Creation At ',
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      width: '200px',
      render: (text, record) => {
        return record?.User?.createdAt;
      }
    },
    {
      title: 'Process Group Name',
      dataIndex: 'process_group_name',
      key: 'process_group_name',
      ellipsis: true,
      width: '200px',
      render: (text, record) => {
        return record?.User?.process_group_name || 'NA';
      }
    }
  ];

  const products_log_columns = [
    {
      title: 'Batch Size',
      dataIndex: 'batch_size',
      key: 'batch_size',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.batch_size || 'NA';
      }
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'batch_size',
      ellipsis: true,
      width: '200px',
      render: (text, record) => {
        return record?.name;
      }
    },
    {
      title: 'BMR BPR Code',
      dataIndex: 'bmr_bpr_code',
      key: 'bmr_bpr_code',
      ellipsis: true,
      width: '150px',
      render: (text, record) => {
        return record?.bmr_bpr_code;
      }
    },
    {
      title: 'Created At',
      dataIndex: 'created_At',
      key: 'created_At',
      ellipsis: true,
      width: '150px',
      render: (text, record) => {
        return record?.createdAt;
      }
    }
  ];

  const trf_generation_log_columns = [
    {
      title: 'Sample Quantity',
      dataIndex: 'sample_quantity',
      key: 'sample_quantity',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.sample_quantity || 'NA';
      }
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      width: '200px',
      render: (text, record) => {
        return record?.createdAt;
      }
    },
    {
      title: 'InHouse Batch-No.',
      dataIndex: 'inhouse_batch_number',
      key: 'inhouse_batch_number',
      ellipsis: true,
      width: '150px',
      render: (text, record) => {
        return record?.batch_detail?.inhouse_batch_number;
      }
    },
    {
      title: 'Invoice Quantity',
      dataIndex: 'invoice_quantity',
      key: 'invoice_quantity',
      ellipsis: true,
      width: '150px',
      render: (text, record) => {
        return record?.batch_detail?.invoice_quantity;
      }
    }
  ];

  const trf_modification_log_columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.id || 'NA';
      }
    },
    {
      title: 'First Name',
      dataIndex: 'first_name',
      key: 'first_name',
      ellipsis: true,
      width: '150px',
      render: (text, record) => {
        return record?.User?.first_name;
      }
    },
    {
      title: 'Last Name',
      dataIndex: 'last_name',
      key: 'last_name',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.User?.last_name || 'NA';
      }
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      width: '200px',
      render: (text, record) => {
        return record?.User?.createdAt;
      }
    }
  ];

  const ebmr_config_log_columns = [
    {
      title: 'Batch Size',
      dataIndex: 'batch_size',
      key: 'batch_size',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.batch_size || 'NA';
      }
    },
    {
      title: 'BMR BPR CODE',
      dataIndex: 'bmr_bpr_code',
      key: 'bmr_bpr_code',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.bmr_bpr_code || 'NA';
      }
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: '150px',
      render: (text, record) => {
        return record?.name;
      }
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      width: '200px',
      render: (text, record) => {
        return record?.createdAt;
      }
    }
  ];

  //For Inhouse-Batch-Status-Log:

  const specificBatchColumns = [
    {
      title: 'InHouse Batch Number',
      dataIndex: 'inhouse_batch_number',
      key: 'inhouse_batch_number',
      ellipsis: true,
      width: '200px',
      render: (text, record) => {
        return record?.batch_detail?.inhouse_batch_number;
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      width: '200px',
      render: (text, record) => {
        return <Tag> {record?.batch_detail?.status || 'NA'}</Tag>;
      }
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      width: '200px',
      render: (text, record) => {
        return moment(record?.batch_detail?.createdAt).format('YYYY-MM-DD');
      }
    },
    {
      title: 'Created By',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: '200px',
      render: (text, record) => {
        return record?.User?.employee_id;
      }
    }
  ];

  const dateRangeColumns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.id;
      }
    },
    {
      title: 'Invoice Quantity',
      dataIndex: 'invoice_quantity',
      key: 'invoice_quantity',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.batch_detail?.invoice_quantity || 'NA';
      }
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      ellipsis: true,
      width: '150px',
      render: (text, record) => {
        return record?.batch_detail?.createdAt;
      }
    },
    {
      title: 'First Name',
      dataIndex: 'first_name',
      key: 'first_name',
      ellipsis: true,
      width: '150px',
      render: (text, record) => {
        return record?.User?.first_name;
      }
    }
  ];

  const vendor_creation_log_columns = [
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      width: '200px',
      render: (text, record) => {
        return record?.createdAt;
      }
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.id;
      }
    },
    {
      title: 'Material Name',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: '150px',
      render: (text, record) => {
        return record?.material?.name || 'NA';
      }
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      ellipsis: true,
      width: '150px',
      render: (text, record) => {
        return record?.updatedAt;
      }
    }
  ];
  const removed_stock_status_logs_columns = [
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      width: '200px',
      render: (text, record) => {
        return moment(record?.createdAt).format('YYYY-MM-DD');
      }
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.id;
      }
    },
    {
      title: 'Inhouse Batch Number',
      dataIndex: 'inhouse_batch_number',
      key: 'inhouse_batch_number',
      ellipsis: true,
      width: '150px',
      render: (text, record) => {
        return (
          record?.removed_stock?.batch_detail?.inhouse_batch_number || 'NA'
        );
      }
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      ellipsis: true,
      width: '150px',
      render: (text, record) => {
        return moment(record?.updatedAt).format('YYYY-MM-DD');
      }
    }
  ];

  const [batchOrDateRange, setBatchOrDateRange] = useState(null); // State to track radio button selection

  const selectedColumns =
    batchOrDateRange === 'specific_batch'
      ? specificBatchColumns
      : specificBatchColumns;
  console.log(dateRangeColumns);
  const [selectedOption, setSelectedOption] = useState('');
  // const [allMaterials, setAllMaterials] = useState([]);
  // const [batches1, setBatches1] = useState([]);

  const handleSelectChange = (value) => {
    setSelectedOption(value);
    // Clear the LC process dropdown when switching report types so stale
    // process options never linger on an unrelated report.
    setLcProcessOptions([]);
    setLcProcessLoading(false);
    setPvProcessOptions([]);
    setPvProcessLoading(false);
    setPvNoResults(false);
  };

  const onChange = (value, type) => {
    const material = allMaterials.filter(
      (MaterialsList) => MaterialsList.id === value
    );

    let payload = { search: material[0].code };
    dispatch(getAllMaterialslist(payload)).then((response) => {
      if (response?.payload?.success) {
        setBatches(response?.payload?.data[0]?.batch_details);
        // dispatch(getAllMaterialslist());
      }
    });
    form.setFieldsValue({ supplier_id: null });
    type == 'id'
      ? form.setFieldsValue({ material_name: value })
      : form.setFieldsValue({ material_id: value });
    // setCode(material[0]);
  };

  const onChangepo = (e) => {
    setPOINV(e);
  };

  const onChangeroom = (e) => {
    setRoomID(e);
  };
  const onSearch = (value) => {
    setSearch(value);
    console.log(value);
  };

  const onChangeBatch = (value) => {
    const batches_details =
      value == 'all'
        ? allMaterials[0]?.batch_details
        : batches.filter((batches) => batches.id === value);
    setBatches(batches_details);
  };

  const onChangeType = (e) => {
    console.log(e);
    setSubType(e.target.value);
  };

  const onSearchBatch = (value) => {
    const batches_details = batches.inhouse_batch_number
      .toLowerCase()
      .includes(value.toLowerCase());
    setBatches(batches_details);
  };

  // const material_columns = [
  //   {
  //     title: 'Inhouse Batch #',
  //     dataIndex: 'inhouse_batch_number',
  //     key: 'inhouse_batch_number',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (text, record) => {
  //       return record?.status == 'Approved' && user?.role == 'user' ? (
  //         // &&
  //         // user?.level == 3
  //         <a href={`stock-card-issuance/${record.id}`}>{text}</a>
  //       ) : (
  //         // text
  //         // text;
  //         <a href={`stock-card-issuance/${record.id}`}>{text}</a>
  //       );
  //     }
  //   },
  //   {
  //     title: 'MRN #',
  //     dataIndex: 'mrn_number',
  //     key: 'mrn_number',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (text, record) => {
  //       return record?.mrn_number || 'NA';
  //     }
  //   },
  //   {
  //     title: 'Status',
  //     dataIndex: 'status',
  //     key: 'status',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (text) => {
  //       return text == 'Approved' ? (
  //         <Tag color="#4CAF50">{text?.toUpperCase()}</Tag>
  //       ) : text == 'Quarantine' ? (
  //         <Tag color="#FF9800">{text?.toUpperCase()}</Tag>
  //       ) : text == 'Expired' ? (
  //         <Tag color="#939089d9">{text?.toUpperCase()}</Tag>
  //       ) : text == 'Rejected' ? (
  //         <Tag color="#fa2a3e">{text?.toUpperCase()}</Tag>
  //       ) : text === 'Under Sampling' ? (
  //         <Tag color="#17a2b8">{text?.toUpperCase()}</Tag>
  //       ) : text === 'Under Test' ? (
  //         <Tag color="#343a40">{text?.toUpperCase()}</Tag>
  //       ) : text === 'OnHold' ? (
  //         <Tag color="#781720">{text?.toUpperCase()}</Tag>
  //       ) : (
  //         <Tag color="#4CAF50">{text?.toUpperCase()}</Tag>
  //       );
  //     }
  //   },

  //   {
  //     title: 'Closing Qty',
  //     dataIndex: 'closing_quantity',
  //     key: 'closing_quantity',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       // var issued_qty = 0;
  //       // record?.stock_card_issuances?.map((item) => {
  //       //   issued_qty += parseFloat(item?.quantity_issued || 0);
  //       // });
  //       console.log(
  //         record?.stock_card_issuances?.[
  //           record?.stock_card_issuances?.length - 1
  //         ]?.closing_balance,
  //         'issued_qty'
  //       );
  //       return (
  //         `${
  //           record?.stock_card_issuances?.[
  //             record?.stock_card_issuances?.length - 1
  //           ]?.closing_balance
  //         }  ${code?.uom}` || 'NA'

  //         // Quantity Received (-) Sampling Quantity (+ or -) Stock Reconciliation Qty (-) Wastage Material Qty (+) Returned Qty
  //         // // `${
  //         // //   parseFloat(record?.received_quantity || 0) -
  //         // //   parseFloat(record?.sampling?.[0]?.total_value || 0) +
  //         // //   parseFloat(
  //         // //     record?.stock_reconsiliation?.[0]?.total_reconcile || 0
  //         // //   ) -
  //         // //   parseFloat(record?.wastage_quantity?.[0]?.total_wastage || 0) +
  //         // //   parseFloat(
  //         // //     record?.stock_card_issuances?.[0]?.quantity_returned || 0
  //         // //   )
  //         // } ${code?.uom}`
  //       );
  //     }
  //   },
  //   {
  //     title: 'Mfg Batch/Lot #',
  //     dataIndex: 'mfg_batch_lot_no',
  //     key: 'mfg_batch_lot_no',
  //     ellipsis: true,
  //     width: '100px'
  //   },
  //   {
  //     title: 'Mfg Date',
  //     dataIndex: 'mfg_date',
  //     key: 'mfg_date',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       return record?.mfg_date
  //         ? moment(record?.mfg_date).format('DD MMM YYYY')
  //         : 'NA';
  //     }
  //   },
  //   {
  //     title: 'Mfg Expiry Date',
  //     dataIndex: 'mfg_expiry_date',
  //     key: 'mfg_expiry_date',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       return record?.mfg_expiry_date
  //         ? moment(record?.mfg_expiry_date).format('DD MMM YYYY')
  //         : 'NA';
  //     }
  //   },
  //   {
  //     title: 'Mfg Re-test Date',
  //     dataIndex: 'mfg_retest_date',
  //     key: 'mfg_retest_date',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       return record?.mfg_retest_date
  //         ? moment(record?.mfg_retest_date).format('DD MMM YYYY')
  //         : 'NA';
  //     }
  //   },
  //   {
  //     title: 'Inhouse Expiry Date',
  //     dataIndex: 'in_house_expiry_date',
  //     key: 'in_house_expiry_date',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       return record?.in_house_expiry_date
  //         ? moment(record?.in_house_expiry_date).format('DD MMM YYYY')
  //         : 'NA';
  //     }
  //   },
  //   {
  //     title: 'Inhouse Retest Date',
  //     dataIndex: 'inhouse_retest_date',
  //     key: 'inhouse_retest_date',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       return record?.inhouse_retest_date
  //         ? moment(record?.inhouse_retest_date).format('DD MMM YYYY')
  //         : 'NA';
  //     }
  //   },
  //   {
  //     title: 'Received Qty',
  //     dataIndex: 'quantity_received',
  //     key: 'quantity_received',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       return (
  //         `${parseFloat(record?.received_quantity || 0).toFixed(3)}  ${
  //           code?.uom
  //         }` || 'NA'
  //       );
  //     }
  //   },
  //   {
  //     title: 'Sampling Qty',
  //     dataIndex: 'sampling_quantity',
  //     key: 'sampling_quantity',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       return (
  //         `${parseFloat(record?.sampling?.[0]?.total_value || 0).toFixed(3)}  ${
  //           code?.uom
  //         }` || 'NA'
  //       );
  //     }
  //   },

  //   {
  //     title: 'Approved Qty',
  //     dataIndex: 'approved_quantity',
  //     key: 'approved_quantity',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       return (
  //         // `${
  //         //   record?.stock_card_issuances?.length
  //         //     ? parseFloat(record?.stock_card_issuances?.[0]?.closing_balance)
  //         //     : parseFloat(record?.received_quantity)
  //         // }  ${code?.uom}` || 'NA'

  //         // Quantity Received (-) Sampling Quantity (+ or -) Stock Reconciliation Qty (-) Wastage Material Qty (+) Returned Qty
  //         record?.status === 'Quarantine'
  //           ? 0
  //           : `${
  //               (
  //                 parseFloat(record?.received_quantity || 0) -
  //                 parseFloat(record?.sampling?.[0]?.total_value || 0)
  //               ).toFixed(3)
  //               //  +
  //               // parseFloat(
  //               //   record?.stock_reconsiliation?.[0]?.total_reconcile || 0
  //               // ) -
  //               // parseFloat(record?.wastage_quantity?.[0]?.total_wastage || 0) +
  //               // parseFloat(
  //               //   record?.stock_card_issuances?.[0]?.quantity_returned || 0
  //               // )
  //             } ${code?.uom}`
  //       );
  //     }
  //   },
  //   {
  //     title: 'Issued Qty',
  //     dataIndex: 'issued_quantity',
  //     key: 'issued_quantity',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       var issued_qty = 0;
  //       record?.stock_card_issuances?.map((item) => {
  //         issued_qty += parseFloat(item?.quantity_issued || 0);
  //       });

  //       return `${parseFloat(issued_qty || 0).toFixed(3)} ${code?.uom}`;
  //     }
  //   },
  //   {
  //     title: 'Stock Reconciliation Qty',
  //     dataIndex: 'stock_reconciliation_qty',
  //     key: 'stock_reconciliation_qty',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       return (
  //         `${parseFloat(
  //           record?.stock_reconsiliation?.[0]?.total_reconcile || 0
  //         ).toFixed(3)}  ${code?.uom}` || 'NA'
  //       );
  //     }
  //   },
  //   {
  //     title: 'Wastage Material Qty',
  //     dataIndex: 'wastage_material_qty',
  //     key: 'wastage_material_qty',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       return (
  //         `${parseFloat(
  //           record?.wastage_quantity?.[0]?.total_wastage || 0
  //         ).toFixed(3)}  ${code?.uom}` || 'NA'
  //       );
  //     }
  //   },
  //   {
  //     title: 'Returned Qty',
  //     dataIndex: 'returned_qty',
  //     key: 'returned_qty',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       return (
  //         `${parseFloat(record?.stock_returned_qty || 0).toFixed(3)}  ${
  //           code?.uom
  //         }` || 'NA'
  //       );
  //     }
  //   },

  //   {
  //     title: 'AR #',
  //     dataIndex: 'ar_number',
  //     key: 'ar_number',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       return record?.sampling_histories?.length
  //         ? record?.sampling_histories[0]?.ar_number
  //         : 'NA' || 'NA';
  //     }
  //   },
  //   {
  //     title: 'Date of Receipt',
  //     dataIndex: 'received_date',
  //     key: 'received_date',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       return record?.sampling_histories?.length
  //         ? record?.sampling_histories[0]?.received_date
  //           ? moment(record?.sampling_histories[0]?.received_date).format(
  //               'DD MMM YYYY'
  //             )
  //           : 'NA'
  //         : 'NA';
  //     }
  //   },
  //   {
  //     title: 'Received by WH',
  //     dataIndex: 'received_by_wh',
  //     key: 'received_by_wh',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       return record?.received_by_wh || 'NA';
  //     }
  //   },
  //   {
  //     title: 'Checked by WH',
  //     dataIndex: 'checked_by_wh',
  //     key: 'checked_by_wh',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       return record?.checked_by_wh || 'NA';
  //     }
  //   },
  //   {
  //     title: 'Sampling Done by QC',
  //     dataIndex: 'sampling_done_by_qc',
  //     key: 'sampling_done_by_qc',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       return record?.sampling_done_by_qc || 'NA';
  //     }
  //   },
  //   {
  //     title: 'Remarks',
  //     dataIndex: 'remarks',
  //     key: 'remarks',
  //     ellipsis: true,
  //     width: '100px',
  //     render: (_, record) => {
  //       return record?.remarks || 'NA';
  //     }
  //   }
  // ];

  return (
    <Layout sider={false}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Card
          title={'VIEW & DOWNLOAD AUDIT REPORT'}
          className={styles.CustomPanel}
        >
          <Row gutter={24}>
            <Col xs={24} xl={8} span={8} md={24} sm={24}>
              <FormItem
                label="Report Name"
                name="report"
                rules={[
                  {
                    required: true,
                    message: 'Select Report'
                  }
                ]}
                className={styles.customLable}
              >
                <Select
                  placeholder="Please Select Report"
                  onChange={handleSelectChange}
                  value={selectedOption}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.children ?? '')
                      .toString()
                      .toLowerCase()
                      .includes((input || '').toLowerCase())
                  }
                >
                  <option value="user_log">User log details</option>
                  {/* Hidden 2026-06-15: superseded by the Material Receipt Audit
                      Trail. Option hidden (not removed) — uncomment to restore;
                      the backend handler + columns remain intact. */}
                  {/* <option value="mrn_log">MRN log details</option> */}
                  <option value="sampling_creation_log">
                    Sampling creation log
                  </option>
                  <option value="sampling_log">
                    Sampling modification log
                  </option>
                  <option value="dispensing_log">Dispensing log details</option>
                  <option value="wastage_log">Wastage log details</option>
                  {/* Hidden 2026-06-15: broken report; failed logins are now
                      shown in "User login & logout details". Option hidden (not
                      removed) — uncomment to restore; handler/columns intact. */}
                  {/* <option value="failed_login">Failed login log details</option> */}
                  <option value="login_logout">
                    User login & logout details
                  </option>
                  <option value="vendor_creation_log">
                    Vendor creation log
                  </option>
                  <option value="vendor_modification_log">
                    Vendor modification log
                  </option>
                  <option value="inhousebatch_status_log">
                    In house batch status log
                  </option>
                  {/* <option value="ebmr_master_modification_log">
                    E-BMR Master modification Log
                  </option> */}
                  <option value="products_log">Products log</option>
                  {/* <option value="ebmr_master_creation_log">
                    E-BMR Master creation Log
                  </option> */}
                  <option value="trf_generation_log">TRF generation log</option>
                  <option value="trf_modification_log">
                    TRF modification log
                  </option>
                  {/* <option value="ebmr_config_log">
                    E-BMR Configuration Log
                  </option> */}
                  {/* <option value="">Vendor Data log</option>
                <option value="">In-House Batch Status log</option>*/}
                  <option value="dispensing_deleted_transactions">
                    Dispensing deleted transactions
                  </option>
                  <option value="material_status_logs">
                    Material status logs
                  </option>

                  <option value="material_modification_logs">
                    Material modification logs
                  </option>
                  <option value="vendor_status_logs">Vendor status logs</option>
                  <option value="removed_stock_status_logs">
                    Removed stock status logs
                  </option>
                  <option value="removed_stock_modification_logs">
                    Removed stock modification logs
                  </option>
                  <option value="EBMR_login_logout">
                    e-BMR login & logout details
                  </option>
                  <option value="EBMR_batch_lifecycle">
                    e-BMR batch lifecycle log
                  </option>
                  <option value="EBMR_Audit_Logs">e-BMR execution log</option>
                  <option value="ebmr_event_log">e-bmr event log</option>

                  {/* <option value="inv_tracker_status">
                    Invoice Tracker logs
                  </option> */}
                  <option value="inward_logs">Inward logs</option>
                  <option value="outward_logs">Outward logs</option>
                  <option value="wip_prod_labels">
                    WIP Inward Outward logs
                  </option>
                  <option value="equipment_logs">Equipment logs</option>
                  <option value="product_batchwise_equipment_log">
                    Product batchwise equipment log report
                  </option>
                  <option value="material_receipt_audit">
                    Material Receipt Audit Trail
                  </option>
                  <option value="wip_label_audit">WIP Label Audit Trail</option>
                  <option value="miscellaneous_label_audit">
                    Miscellaneous Label Audit Trail
                  </option>
                  <option value="move_material_audit">
                    Material Movement Audit Trail
                  </option>
                  <option value="mrr_audit">
                    Material Return Request Audit Trail
                  </option>
                  <option value="lc_material_verification_audit">
                    Line Clearance Material Verification Audit Trail
                  </option>
                  <option value="product_verification_audit">
                    Line Clearance Product Verification Audit Trail
                  </option>
                </Select>
              </FormItem>
            </Col>
            {selectedOption === 'inv_tracker_status' && (
              <Col xs={24} xl={6} span={6} md={24} sm={24}>
                <FormItem
                  label="Select Type"
                  rules={[
                    {
                      required: true,
                      message: 'Enter Select date'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Radio.Group onChange={onChangeType}>
                    <Radio value="po_num">PO No.</Radio>
                    <Radio value="invoice_num">Invoice No.</Radio>
                    <Radio value="date_range">Date</Radio>
                  </Radio.Group>
                </FormItem>
              </Col>
            )}
            {(selectedOption === 'wip_prod_labels' ||
              selectedOption === 'outward_logs' ||
              selectedOption === 'inward_logs') && (
              <Col xs={24} xl={6} span={6} md={24} sm={24}>
                <FormItem
                  label="Select Room"
                  rules={[
                    {
                      required: true,
                      message: 'Enter Select room'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    showSearch
                    placeholder="Select room"
                    optionFilterProp="children"
                    onChange={(e) => onChangeroom(e, 'id')}
                    onSearch={onSearch}
                  >
                    {rooms ? (
                      rooms?.map((room, index) => {
                        return (
                          <option value={room.id} key={index}>
                            {room.room_no}
                          </option>
                        );
                      })
                    ) : (
                      <Spin />
                    )}
                  </Select>
                </FormItem>
              </Col>
            )}
            {selectedOption === 'equipment_logs' && (
              <Col xs={24} xl={6} span={6} md={24} sm={24}>
                <FormItem
                  label="Select Equipment"
                  rules={[
                    {
                      required: true,
                      message: 'Enter Select room'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    showSearch
                    placeholder="Select Equipment"
                    optionFilterProp="children"
                    onChange={(e) => onChangeroom(e, 'id')}
                    onSearch={onSearch}
                  >
                    {equipmentsList ? (
                      equipmentsList?.map((equipment, index) => {
                        return (
                          <option value={equipment.equipment_id} key={index}>
                            {equipment.equipment_id}
                          </option>
                        );
                      })
                    ) : (
                      <Spin />
                    )}
                  </Select>
                </FormItem>
              </Col>
            )}
            {selectedOption === 'equipment_logs' && (
              <Col xs={24} xl={8} span={8} md={24} sm={24}>
                <FormItem
                  label="Select start and end date (optional)"
                  name="equipment_date_range"
                  className={styles.customLable}
                  extra="Leave empty to include all logs for the equipment"
                >
                  <RangePicker
                    format="DD-MM-YYYY"
                    disabledDate={(current) =>
                      current && current.valueOf() > Date.now()
                    }
                    style={{ width: '100%' }}
                  />
                </FormItem>
              </Col>
            )}
            {selectedOption === 'product_batchwise_equipment_log' && (
              <Col xs={24} xl={6} span={6} md={24} sm={24}>
                <FormItem
                  label="Select Product Batch"
                  name="stage1_batch"
                  rules={[
                    {
                      required: true,
                      message: 'Select a Product batch'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    showSearch
                    placeholder="Select Product batch"
                    filterOption={false}
                    onChange={(e) => setStage1Batch(e)}
                    onSearch={onStage1SearchDebounced}
                  >
                    {stage1Batches?.map((batch, index) => (
                      <option value={batch?.product_batch} key={index}>
                        {batch?.label}
                      </option>
                    ))}
                  </Select>
                </FormItem>
              </Col>
            )}
            {selectedOption === 'material_receipt_audit' && (
              <>
                <Col xs={24} xl={6} span={6} md={24} sm={24}>
                  <FormItem
                    label="Invoice Number"
                    name="invoice_number"
                    className={styles.customLable}
                  >
                    <Input placeholder="e.g. INV-2026-00123" allowClear />
                  </FormItem>
                </Col>
                <Col xs={24} xl={8} span={8} md={24} sm={24}>
                  <FormItem
                    label="OR select start and end date"
                    name="receipt_range"
                    className={styles.customLable}
                    extra="Pick a date range to choose up to 5 receipts for one combined report"
                  >
                    <RangePicker
                      style={{ width: '100%' }}
                      format="YYYY-MM-DD"
                    />
                  </FormItem>
                </Col>
              </>
            )}
            {selectedOption === 'wip_label_audit' && (
              <Col xs={24} xl={6} span={6} md={24} sm={24}>
                <FormItem
                  label="Batch Number"
                  name="batch_no"
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: 'Enter batch number'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Input placeholder="e.g. CATCB23193" />
                </FormItem>
              </Col>
            )}
            {selectedOption === 'move_material_audit' && (
              <Col xs={24} xl={6} span={6} md={24} sm={24}>
                <FormItem
                  label="Batch Number"
                  name="batch_number"
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: 'Enter batch number'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Input placeholder="e.g. CATCB23193 or B26000123" />
                </FormItem>
              </Col>
            )}
            {selectedOption === 'lc_material_verification_audit' && (
              <>
                <Col xs={24} xl={6} span={6} md={24} sm={24}>
                  <FormItem
                    label="Product Batch Number"
                    name="lc_product_batch_number"
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                        message: 'Enter product batch number'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input
                      placeholder="e.g. CBPSB26053"
                      onChange={(e) => onLcBatchChange(e.target.value)}
                      allowClear
                    />
                  </FormItem>
                </Col>
                <Col xs={24} xl={8} span={8} md={24} sm={24}>
                  <FormItem
                    label="Process / Sub-process"
                    name="lc_process_combo"
                    rules={[
                      {
                        required: true,
                        message: 'Select a process / sub-process'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Select
                      placeholder={
                        lcProcessLoading
                          ? 'Loading process steps…'
                          : lcProcessOptions.length
                          ? 'Select process / sub-process'
                          : 'Enter batch number first'
                      }
                      loading={lcProcessLoading}
                      disabled={!lcProcessOptions.length}
                      notFoundContent={
                        lcProcessLoading ? (
                          <Spin size="small" />
                        ) : (
                          'No process steps'
                        )
                      }
                    >
                      {lcProcessOptions.map((o) => (
                        <option value={o.id} key={o.id}>
                          {lcProcessLabel(o)}
                        </option>
                      ))}
                    </Select>
                  </FormItem>
                </Col>
              </>
            )}
            {selectedOption === 'product_verification_audit' && (
              <>
                <Col xs={24} xl={6} span={6} md={24} sm={24}>
                  <FormItem
                    label={labelWithInfo(
                      'Batch Number',
                      "Enter any batch from this product's lineage — blend, intermediate, or packing (e.g. CBPSB26055). The report finds every product verification across all its stages."
                    )}
                    name="pv_batch_number"
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                        message: 'Enter a batch number'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input
                      placeholder="Any stage's batch — e.g. CBPSB26055"
                      onChange={(e) => onPvBatchChange(e.target.value)}
                      allowClear
                    />
                  </FormItem>
                </Col>
                <Col xs={24} sm={24} md={24} xl={12} span={12}>
                  <FormItem
                    label={labelWithInfo(
                      'Select the stage to view',
                      'Each option is one product verification: the stage where it happened, the batch at that stage, and the previous stage and batch the material came from.'
                    )}
                    name="pv_process_combo"
                    rules={[
                      {
                        required: true,
                        message: 'Select a stage'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Select
                      placeholder={
                        pvProcessLoading
                          ? 'Loading stages…'
                          : pvProcessOptions.length
                          ? 'Select the stage to view'
                          : pvNoResults
                          ? 'No product verifications found for this batch'
                          : 'Enter a batch number first'
                      }
                      loading={pvProcessLoading}
                      disabled={!pvProcessOptions.length}
                      // Let the dropdown popup size to the longest option so the
                      // full "Stage — batch · from stage (batch)" text is readable
                      // on laptops and tablets alike.
                      dropdownMatchSelectWidth={false}
                      dropdownStyle={{ maxWidth: '90vw' }}
                      optionLabelProp="children"
                      notFoundContent={
                        pvProcessLoading ? (
                          <Spin size="small" />
                        ) : (
                          'No stages found'
                        )
                      }
                    >
                      {pvProcessOptions.map((o) => (
                        <option
                          value={o.key}
                          key={o.key}
                          title={pvProcessLabel(o)}
                        >
                          {pvProcessLabel(o)}
                        </option>
                      ))}
                    </Select>
                  </FormItem>
                </Col>
              </>
            )}
            {selectedOption === 'mrr_audit' && (
              <>
                <Col xs={24} xl={8} span={8} md={24} sm={24}>
                  <FormItem
                    label="MRR Number"
                    name="mrr_number"
                    className={styles.customLable}
                  >
                    <Input placeholder="e.g. 4767/26" allowClear />
                  </FormItem>
                </Col>
                <Col xs={24} xl={8} span={8} md={24} sm={24}>
                  <FormItem
                    label="Product Batch Number"
                    name="mrr_product_batch_number"
                    className={styles.customLable}
                    extra="Enter either MRR Number or Product Batch Number"
                  >
                    <Input placeholder="e.g. CGACB23037" allowClear />
                  </FormItem>
                </Col>
              </>
            )}
            {selectedOption === 'miscellaneous_label_audit' && (
              <>
                <Col xs={24} xl={8} span={8} md={24} sm={24}>
                  <FormItem
                    label="Select start and end date"
                    name="msc_range"
                    className={styles.customLable}
                  >
                    <RangePicker
                      style={{ width: '100%' }}
                      format="YYYY-MM-DD"
                    />
                  </FormItem>
                </Col>
                <Col xs={24} xl={6} span={6} md={24} sm={24}>
                  <FormItem
                    label="OR Container ID"
                    name="msc_id"
                    className={styles.customLable}
                  >
                    <Input placeholder="e.g. MSC-26-0001" />
                  </FormItem>
                </Col>
              </>
            )}

            {selectedOption === 'inv_tracker_status' && (
              <>
                {subType === 'po_num' ? (
                  <Col xs={24} xl={8} span={12} md={24} sm={24}>
                    <FormItem
                      label="Enter PO Number"
                      name="po_no"
                      rules={[
                        {
                          required: true,
                          message: 'Enter Select date'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Select
                        showSearch
                        placeholder="Select a PO number"
                        optionFilterProp="children"
                        onChange={(e) => onChangepo(e, 'id')}
                        onSearch={onSearch}
                      >
                        {poNumbers ? (
                          poNumbers?.map((item, index) => {
                            return (
                              <option value={item.po_no} key={index}>
                                {item.po_no}
                              </option>
                            );
                          })
                        ) : (
                          <Spin />
                        )}
                      </Select>
                    </FormItem>
                  </Col>
                ) : subType === 'invoice_num' ? (
                  <Col xs={24} xl={8} span={12} md={24} sm={24}>
                    <FormItem
                      label="Enter Invoice Number"
                      name="inv_no"
                      rules={[
                        {
                          required: true,
                          message: 'Enter Select date'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Select
                        showSearch
                        placeholder="Select a Invoice number"
                        optionFilterProp="children"
                        onChange={(e) => onChangepo(e, 'id')}
                        onSearch={onSearch}
                      >
                        {poNumbers ? (
                          poNumbers?.map((item, index) => {
                            return (
                              <option value={item.invoice_no} key={index}>
                                {item.invoice_no}
                              </option>
                            );
                          })
                        ) : (
                          <Spin />
                        )}
                      </Select>
                    </FormItem>
                  </Col>
                ) : (
                  subType === 'date_range' && (
                    <Col xs={24} xl={8} span={12} md={24} sm={24}>
                      <FormItem
                        label="Select start and end date"
                        name="fromDate"
                        rules={[
                          {
                            required: true,
                            message: 'Enter Select date'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <RangePicker
                          format={'DD-MM-YYYY'}
                          onChange={(x) => {
                            setDateRange(x);
                          }}
                          // disabledDate={
                          //   futerdate
                          //     ? (current) => {
                          //         return current && current.valueOf() > Date.now();
                          //       }
                          //     : false
                          // }
                          value={dateRange}
                          // separator={'-'}
                          style={{ width: '100%' }}
                        />
                      </FormItem>
                    </Col>
                  )
                )}
              </>
            )}
            {(selectedOption === 'EBMR_batch_lifecycle' ||
              selectedOption === 'EBMR_Audit_Logs') && (
              <Col xs={24} xl={12} span={12} md={24} sm={24}>
                <FormItem
                  label="Select Batch"
                  rules={[
                    {
                      required: true,
                      message: 'Enter Select room'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    showSearch
                    mode="multiple"
                    placeholder="Select Batch"
                    optionFilterProp="children"
                    value={selectedBatchIds}
                    onChange={(e) => handleChangeBatch(e)}
                    onSearch={onSearch}
                  >
                    {dataSource ? (
                      dataSource?.map((batch, index) => {
                        return (
                          <option value={batch.id} key={index}>
                            {batch.product_batch_number}
                          </option>
                        );
                      })
                    ) : (
                      <Spin />
                    )}
                  </Select>
                </FormItem>
              </Col>
            )}
            {selectedOption === 'inhousebatch_status_log' ? (
              <>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="Select Batch or Date Range"
                    name="batchOrDateRange"
                    rules={[
                      {
                        required: true,
                        message: 'Please select an option'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Radio.Group
                      onChange={(e) => setBatchOrDateRange(e.target.value)}
                    >
                      <Radio value="specific_batch">Specific Batch</Radio>
                      <Radio value="date_range">Date Range</Radio>
                    </Radio.Group>
                  </FormItem>
                </Col>
                {batchOrDateRange === 'specific_batch' && (
                  <>
                    <Col xs={24} xl={24} span={24} md={24} sm={24}>
                      <Row gutter={24}>
                        <Col xs={24} xl={12} span={12} md={24} sm={24}>
                          <FormItem
                            label="Material Code"
                            name="material_id"
                            rules={[
                              {
                                required: true,
                                message: 'Select Material Code'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Select
                              showSearch
                              placeholder="Select a material code"
                              optionFilterProp="children"
                              onChange={(e) => onChange(e, 'id')}
                              onSearch={onSearch}
                            >
                              {allMaterials ? (
                                allMaterials?.map((item, index) => {
                                  return (
                                    <option value={item.id} key={index}>
                                      {item.code}
                                    </option>
                                  );
                                })
                              ) : (
                                <Spin />
                              )}
                            </Select>
                          </FormItem>
                        </Col>

                        <Col xs={24} xl={6} span={12} md={24} sm={24}>
                          <FormItem
                            label="In House Batch #"
                            name="inhouse_batch_id"
                            rules={[
                              {
                                required: true,
                                message: 'Select In House Batch Number'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Select
                              showSearch
                              placeholder="Select In House Batch Number"
                              optionFilterProp="children"
                              onChange={onChangeBatch}
                              onSearch={onSearchBatch}
                            >
                              {batches?.map((item, index) => {
                                return (
                                  <option value={item.id} key={index}>
                                    {item.inhouse_batch_number}
                                  </option>
                                );
                              })}
                            </Select>
                          </FormItem>
                        </Col>
                      </Row>
                    </Col>
                  </>
                )}

                {batchOrDateRange === 'date_range' && (
                  <FormItem
                    label="Select start and end date"
                    name="fromDate"
                    rules={[
                      {
                        required: true,
                        message: 'Enter Select date'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <RangePicker
                      format={'DD-MM-YYYY'}
                      onChange={(x) => setDateRange(x)}
                      disabledDate={(current) =>
                        current && current.valueOf() > Date.now()
                      }
                      value={dateRange}
                      style={{ width: '100%' }}
                    />
                  </FormItem>
                )}
              </>
            ) : (
              selectedOption &&
              selectedOption !== 'inv_tracker_status' &&
              selectedOption !== 'equipment_logs' &&
              selectedOption !== 'product_batchwise_equipment_log' &&
              selectedOption !== 'EBMR_batch_lifecycle' &&
              selectedOption !== 'EBMR_Audit_Logs' &&
              selectedOption !== 'material_receipt_audit' &&
              selectedOption !== 'wip_label_audit' &&
              selectedOption !== 'miscellaneous_label_audit' &&
              selectedOption !== 'move_material_audit' &&
              selectedOption !== 'mrr_audit' &&
              selectedOption !== 'lc_material_verification_audit' &&
              selectedOption !== 'product_verification_audit' && (
                <FormItem
                  label="Select start and end date"
                  name="fromDate"
                  rules={[
                    {
                      required: false,
                      message: 'Enter Select date'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <RangePicker
                    format={'DD-MM-YYYY'}
                    onChange={(x) => setDateRange(x)}
                    disabledDate={(current) =>
                      current && current.valueOf() > Date.now()
                    }
                    value={dateRange}
                    style={{ width: '100%' }}
                  />
                </FormItem>
              )
            )}
          </Row>
        </Card>
        <br />
        <FormItem className="text-center">
          <Space>
            {selectedOption === 'wip_prod_labels' ||
            selectedOption === 'outward_logs' ||
            selectedOption === 'inward_logs' ||
            selectedOption === 'equipment_logs' ||
            selectedOption === 'product_batchwise_equipment_log' ||
            selectedOption === 'EBMR_batch_lifecycle' ||
            selectedOption === 'EBMR_login_logout' ||
            selectedOption === 'EBMR_Audit_Logs' ||
            selectedOption === 'ebmr_event_log' ? (
              <CustomButton
                className={styles.inwardButton}
                htmlType="submit"
                type="primary"
                loading={loading}
                disabled={loading}
              >
                {loading ? 'Generating...' : 'Download'}
              </CustomButton>
            ) : (
              <CustomButton
                className={styles.inwardButton}
                htmlType="submit"
                type="primary"
              >
                View
              </CustomButton>
            )}
            <CustomButton
              className={styles.inwardButton}
              type="primary"
              ghost
              onClick={() => history.back()}
            >
              Back
            </CustomButton>
          </Space>
        </FormItem>
        {showTable ? (
          <Card
            className={`${styles.subpanel}`}
            extra={
              <Space>
                {(type === 'user_log' ||
                  type === 'login_logout' ||
                  type === 'failed_login') && (
                  <CustomButton
                    onClick={() => setFilteredInfo({})}
                    size="small"
                  >
                    Clear Filters
                  </CustomButton>
                )}
                {type === 'material_receipt_audit' && (
                  <CustomButton
                    type="primary"
                    ghost
                    onClick={() => {
                      const document_id = audit_receipt?.id;
                      if (!document_id) {
                        message.error('Select a receipt before exporting.');
                        return;
                      }
                      setLoading(true);
                      dispatch(downloadMaterialReceiptAuditPdf({ document_id }))
                        .then((response) => {
                          if (response?.payload?.success) {
                            // Container is private — open via the storage proxy
                            // (REACT_APP_STORAGE_URL + blob name), matching the
                            // existing AuditDownload pattern at line ~325.
                            window.open(
                              `${
                                process.env.REACT_APP_STORAGE_URL
                              }${response.payload.data.split('/').pop()}`,
                              '_blank'
                            );
                            message.success('Audit trail PDF generated');
                          } else {
                            message.error(
                              response?.payload?.message ||
                                'Failed to generate PDF'
                            );
                          }
                        })
                        .finally(() => setLoading(false));
                    }}
                  >
                    {!loading ? <DownloadOutlined /> : <Spin />}
                  </CustomButton>
                )}
                {type === 'wip_label_audit' && audit_receipt && (
                  <CustomButton
                    type="primary"
                    ghost
                    onClick={() => {
                      if (!audit_receipt._prod_dispenses_id) {
                        message.error(
                          'Open a labelling session before exporting.'
                        );
                        return;
                      }
                      setLoading(true);
                      dispatch(
                        downloadWipLabelPdf({
                          prod_dispenses_id: audit_receipt._prod_dispenses_id
                        })
                      )
                        .then((response) => {
                          if (response?.payload?.success) {
                            window.open(
                              `${
                                process.env.REACT_APP_STORAGE_URL
                              }${response.payload.data.split('/').pop()}`,
                              '_blank'
                            );
                            message.success('Audit trail PDF generated');
                          } else {
                            message.error(
                              response?.payload?.message ||
                                'Failed to generate PDF'
                            );
                          }
                        })
                        .finally(() => setLoading(false));
                    }}
                  >
                    {!loading ? <DownloadOutlined /> : <Spin />}
                  </CustomButton>
                )}
                {type === 'miscellaneous_label_audit' && audit_receipt && (
                  <CustomButton
                    type="primary"
                    ghost
                    onClick={() => {
                      if (!audit_receipt._id) {
                        message.error(
                          'Open a miscellaneous container before exporting.'
                        );
                        return;
                      }
                      setLoading(true);
                      dispatch(downloadMscLabelPdf({ id: audit_receipt._id }))
                        .then((response) => {
                          if (response?.payload?.success) {
                            window.open(
                              `${
                                process.env.REACT_APP_STORAGE_URL
                              }${response.payload.data.split('/').pop()}`,
                              '_blank'
                            );
                            message.success('Audit trail PDF generated');
                          } else {
                            message.error(
                              response?.payload?.message ||
                                'Failed to generate PDF'
                            );
                          }
                        })
                        .finally(() => setLoading(false));
                    }}
                  >
                    {!loading ? <DownloadOutlined /> : <Spin />}
                  </CustomButton>
                )}
                {type === 'move_material_audit' && audit_receipt && (
                  <CustomButton
                    type="primary"
                    ghost
                    onClick={() => {
                      const sel = audit_receipt._selector;
                      if (!sel || !sel.batch_number || !sel.batch_kind) {
                        message.error('Open a batch before exporting.');
                        return;
                      }
                      setLoading(true);
                      dispatch(downloadMoveMaterialAuditPdf(sel))
                        .then((response) => {
                          if (response?.payload?.success) {
                            window.open(
                              `${
                                process.env.REACT_APP_STORAGE_URL
                              }${response.payload.data.split('/').pop()}`,
                              '_blank'
                            );
                            message.success('Audit trail PDF generated');
                          } else {
                            message.error(
                              response?.payload?.message ||
                                'Failed to generate PDF'
                            );
                          }
                        })
                        .finally(() => setLoading(false));
                    }}
                  >
                    {!loading ? <DownloadOutlined /> : <Spin />}
                  </CustomButton>
                )}
                {type === 'mrr_audit' && audit_receipt && (
                  <CustomButton
                    type="primary"
                    ghost
                    onClick={() => {
                      const sel = audit_receipt._selector;
                      if (
                        !sel ||
                        (!sel.mrr_number && !sel.product_batch_number)
                      ) {
                        message.error('Open an MRR before exporting.');
                        return;
                      }
                      setLoading(true);
                      dispatch(downloadMrrAuditPdf(sel))
                        .then((response) => {
                          if (response?.payload?.success) {
                            window.open(
                              `${
                                process.env.REACT_APP_STORAGE_URL
                              }${response.payload.data.split('/').pop()}`,
                              '_blank'
                            );
                            message.success('Audit trail PDF generated');
                          } else {
                            message.error(
                              response?.payload?.message ||
                                'Failed to generate PDF'
                            );
                          }
                        })
                        .finally(() => setLoading(false));
                    }}
                  >
                    {!loading ? <DownloadOutlined /> : <Spin />}
                  </CustomButton>
                )}
                {type === 'lc_material_verification_audit' && audit_receipt && (
                  <CustomButton
                    type="primary"
                    ghost
                    onClick={() => {
                      const drid = audit_receipt._dispensing_request_id;
                      if (!drid) {
                        message.error(
                          'Open a material verification before exporting.'
                        );
                        return;
                      }
                      setLoading(true);
                      dispatch(
                        downloadLcMatVerPdf({ dispensing_request_id: drid })
                      )
                        .then((response) => {
                          if (response?.payload?.success) {
                            window.open(
                              `${
                                process.env.REACT_APP_STORAGE_URL
                              }${response.payload.data.split('/').pop()}`,
                              '_blank'
                            );
                            message.success('Audit trail PDF generated');
                          } else {
                            message.error(
                              response?.payload?.message ||
                                'Failed to generate PDF'
                            );
                          }
                        })
                        .finally(() => setLoading(false));
                    }}
                  >
                    {!loading ? <DownloadOutlined /> : <Spin />}
                  </CustomButton>
                )}
                {type === 'product_verification_audit' && audit_receipt && (
                  <CustomButton
                    type="primary"
                    ghost
                    onClick={() => {
                      const sel = audit_receipt._selector;
                      if (
                        !sel ||
                        !sel.process_id ||
                        !sel.previous_batch_number ||
                        (!sel.packing_dispensing_request_id &&
                          !sel.lc_bmr_eqp_id)
                      ) {
                        message.error(
                          'Open a product verification before exporting.'
                        );
                        return;
                      }
                      setLoading(true);
                      dispatch(downloadProdVerPdf(sel))
                        .then((response) => {
                          if (response?.payload?.success) {
                            window.open(
                              `${
                                process.env.REACT_APP_STORAGE_URL
                              }${response.payload.data.split('/').pop()}`,
                              '_blank'
                            );
                            message.success('Audit trail PDF generated');
                          } else {
                            message.error(
                              response?.payload?.message ||
                                'Failed to generate PDF'
                            );
                          }
                        })
                        .finally(() => setLoading(false));
                    }}
                  >
                    {!loading ? <DownloadOutlined /> : <Spin />}
                  </CustomButton>
                )}
                {![
                  'material_receipt_audit',
                  'wip_label_audit',
                  'miscellaneous_label_audit',
                  'move_material_audit',
                  'mrr_audit',
                  'lc_material_verification_audit',
                  'product_verification_audit'
                ].includes(type) && (
                  <CustomButton type="primary" ghost onClick={downloadReport}>
                    {!loading ? <DownloadOutlined /> : <Spin />}
                  </CustomButton>
                )}
              </Space>
            }
          >
            {type === 'material_receipt_audit' && audit_receipt && (
              <div style={{ marginBottom: 16 }}>
                <Row gutter={16}>
                  <Col span={6}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      Invoice Number
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.invoice_number || 'N/A'}
                    </div>
                  </Col>
                  <Col span={6}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      Receipt Created
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.createdAt
                        ? moment(audit_receipt.createdAt).format('DD MMM YYYY')
                        : 'N/A'}
                    </div>
                  </Col>
                  <Col span={6}>
                    <div style={{ fontSize: 12, color: '#888' }}>Status</div>
                    <Tag
                      color={
                        audit_receipt.status === 'MRN INITIATED'
                          ? '#28a745'
                          : '#2db7f5'
                      }
                    >
                      {audit_receipt.status || 'N/A'}
                    </Tag>
                  </Col>
                  <Col span={6}>
                    <div style={{ fontSize: 12, color: '#888' }}>Up Next</div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.up_next || 'N/A'}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
            {type === 'wip_label_audit' && audit_receipt && (
              <div style={{ marginBottom: 16 }}>
                <Row gutter={16}>
                  <Col span={5}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      Batch Number
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.batch_no || 'N/A'}
                    </div>
                  </Col>
                  <Col span={5}>
                    <div style={{ fontSize: 12, color: '#888' }}>Process</div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.process || 'N/A'}
                    </div>
                  </Col>
                  <Col span={3}>
                    <div style={{ fontSize: 12, color: '#888' }}>Lot</div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.lot_no || 'N/A'}
                    </div>
                  </Col>
                  <Col span={5}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      Next Process
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.next_process || 'N/A'}
                    </div>
                  </Col>
                  <Col span={3}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      Containers
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.no_of_containers || 'N/A'}
                    </div>
                  </Col>
                  <Col span={3}>
                    <div style={{ fontSize: 12, color: '#888' }}>Status</div>
                    <Tag
                      color={
                        audit_receipt.status === 'Active' ? '#28a745' : '#888'
                      }
                    >
                      {audit_receipt.status || 'N/A'}
                    </Tag>
                  </Col>
                </Row>
              </div>
            )}
            {type === 'miscellaneous_label_audit' && audit_receipt && (
              <div style={{ marginBottom: 16 }}>
                <Row gutter={16}>
                  <Col span={5}>
                    <div style={{ fontSize: 12, color: '#888' }}>Container</div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.msc_containers || 'N/A'}
                    </div>
                  </Col>
                  <Col span={6}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      Description
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.description || 'N/A'}
                    </div>
                  </Col>
                  <Col span={6}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      Tare / Net / Gross (KG)
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      {`${audit_receipt.tare_wt || 'N/A'} / ${
                        audit_receipt.net_wt || 'N/A'
                      } / ${audit_receipt.gross_wt || 'N/A'}`}
                    </div>
                  </Col>
                  <Col span={4}>
                    <div style={{ fontSize: 12, color: '#888' }}>Balance</div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.bal_booth_id || 'N/A'}
                    </div>
                  </Col>
                  <Col span={3}>
                    <div style={{ fontSize: 12, color: '#888' }}>Status</div>
                    <Tag
                      color={
                        audit_receipt.status === 'Active' ? '#28a745' : '#888'
                      }
                    >
                      {audit_receipt.status || 'N/A'}
                    </Tag>
                  </Col>
                </Row>
              </div>
            )}
            {type === 'move_material_audit' && audit_receipt && (
              <div style={{ marginBottom: 16 }}>
                <Row gutter={16}>
                  <Col span={6}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      Batch Number
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.number || 'N/A'}
                    </div>
                  </Col>
                  <Col span={5}>
                    <div style={{ fontSize: 12, color: '#888' }}>Kind</div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.kind === 'raw'
                        ? 'Raw Material'
                        : audit_receipt.kind === 'prod'
                        ? 'Product / WIP'
                        : 'N/A'}
                    </div>
                  </Col>
                  <Col span={7}>
                    <div style={{ fontSize: 12, color: '#888' }}>Material</div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.material_name || 'N/A'}
                      {audit_receipt.material_code &&
                        audit_receipt.material_code !== 'N/A' &&
                        ` (${audit_receipt.material_code})`}
                    </div>
                  </Col>
                  <Col span={6}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      Current Status
                    </div>
                    <Tag color="#2db7f5">
                      {audit_receipt.current_status || 'N/A'}
                    </Tag>
                  </Col>
                </Row>
              </div>
            )}
            {type === 'mrr_audit' && audit_receipt && (
              <div style={{ marginBottom: 16 }}>
                <Row gutter={16}>
                  <Col span={6}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      MRR Number
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.MRR_number || 'N/A'}
                    </div>
                  </Col>
                  <Col span={6}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      Product Batch
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.product_batch_number || 'N/A'}
                    </div>
                  </Col>
                  <Col span={7}>
                    <div style={{ fontSize: 12, color: '#888' }}>Product</div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.product_name || 'N/A'}
                    </div>
                  </Col>
                  <Col span={5}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      Current Status
                    </div>
                    <Tag color="#2db7f5">
                      {audit_receipt.current_status || 'N/A'}
                    </Tag>
                  </Col>
                </Row>
              </div>
            )}
            {type === 'lc_material_verification_audit' && audit_receipt && (
              <div style={{ marginBottom: 16 }}>
                <Row gutter={16}>
                  <Col span={6}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      Product Batch
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.product_batch_number || 'N/A'}
                    </div>
                  </Col>
                  <Col span={8}>
                    <div style={{ fontSize: 12, color: '#888' }}>Product</div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.product_name || 'N/A'}
                    </div>
                  </Col>
                  <Col span={5}>
                    <div style={{ fontSize: 12, color: '#888' }}>Process</div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.process || 'N/A'}
                      {audit_receipt.sub_process &&
                      audit_receipt.sub_process !== 'N/A'
                        ? ` › ${audit_receipt.sub_process}`
                        : ''}
                    </div>
                  </Col>
                  <Col span={5}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      Material Verification Status
                    </div>
                    <Tag color="#2db7f5">{audit_receipt.status || 'N/A'}</Tag>
                  </Col>
                </Row>
              </div>
            )}
            {type === 'product_verification_audit' && audit_receipt && (
              <div style={{ marginBottom: 16 }}>
                <Row gutter={16}>
                  <Col span={5}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      Verified at Stage
                    </div>
                    <Tag color="#2db7f5">
                      {audit_receipt.verified_at_stage || 'N/A'}
                    </Tag>
                  </Col>
                  <Col span={5}>
                    <div style={{ fontSize: 12, color: '#888' }}>Product</div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.product_name || 'N/A'}
                    </div>
                  </Col>
                  <Col span={5}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      Batch (this stage)
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.packing_batch_number || 'N/A'}
                    </div>
                  </Col>
                  <Col span={4}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      Previous Stage
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.process || 'N/A'}
                    </div>
                  </Col>
                  <Col span={5}>
                    <div style={{ fontSize: 12, color: '#888' }}>
                      Previous Batch
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      {audit_receipt.previous_batch_number || 'N/A'}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
            <div className={`${styles.table_container}`}>
              <CustomTable
                columns={
                  type === 'inhousebatch_status_log'
                    ? selectedColumns
                    : type === 'failed_login'
                    ? logcolumns
                    : type === 'login_logout'
                    ? login_logout_columns
                    : type === 'dispensing_deleted_transactions'
                    ? dispensing_deleted_transactions_columns
                    : type === 'ebmr_master_creation_log'
                    ? ebmr_master_creation_log_columns
                    : type === 'products_log'
                    ? products_log_columns
                    : type === 'trf_generation_log'
                    ? trf_generation_log_columns
                    : type === 'trf_modification_log'
                    ? trf_modification_log_columns
                    : type === 'ebmr_config_log'
                    ? ebmr_config_log_columns
                    : type === 'vendor_creation_log'
                    ? vendor_creation_log_columns
                    : type === 'removed_stock_status_logs'
                    ? removed_stock_status_logs_columns
                    : type === 'material_status_logs'
                    ? matstatuscolumns
                    : type === 'vendor_status_logs'
                    ? venstatuscolumns
                    : type === 'sampling_creation_log'
                    ? SamplingCreationcolumns
                    : type === 'sampling_log'
                    ? samplingModificationColumns
                    : type === 'user_log'
                    ? user_log_columns
                    : type === 'material_receipt_audit'
                    ? material_receipt_audit_columns
                    : type === 'wip_label_audit'
                    ? material_receipt_audit_columns
                    : type === 'miscellaneous_label_audit'
                    ? material_receipt_audit_columns
                    : type === 'move_material_audit'
                    ? material_receipt_audit_columns
                    : type === 'mrr_audit'
                    ? material_receipt_audit_columns
                    : type === 'lc_material_verification_audit'
                    ? material_receipt_audit_columns
                    : type === 'product_verification_audit'
                    ? material_receipt_audit_columns
                    : columns
                }
                pagination={
                  // Client-loaded timeline reports render their whole event list
                  // in one page (CustomTable does not slice), so a server-style
                  // pager here would show phantom pages and, on click, refetch and
                  // wipe the trail. Server-paged report types keep the full pager.
                  CLIENT_TIMELINE_REPORT_TYPES.includes(type)
                    ? false
                    : {
                        size: 'small',
                        total: pagination?.total_records || 0,
                        pageSize: pageSize,
                        current: page,
                        onChange: (newPage, newSize) => {
                          if (newSize !== pageSize) {
                            setPageSize(newSize);
                            setPage(1);
                          } else {
                            setPage(newPage);
                          }
                        }
                      }
                }
                showPaginationMeta
                scroll={{ x: 'auto' }}
                dataSource={
                  type === 'failed_login' ? failedLogData : reportData || []
                }
                onChange={(_, filters) => {
                  if (
                    type === 'user_log' ||
                    type === 'login_logout' ||
                    type === 'failed_login'
                  )
                    setFilteredInfo(filters);
                }}
              />
            </div>
            {type === 'move_material_audit' && (
              <div style={{ marginTop: 24 }}>
                <div style={{ marginBottom: 8 }}>
                  <span
                    style={{ fontSize: 14, fontWeight: 600, color: '#444' }}
                  >
                    Bin Label Print Events
                  </span>
                </div>
                <div className={`${styles.table_container}`}>
                  <CustomTable
                    columns={material_receipt_audit_columns}
                    dataSource={movePrintEvents || []}
                    // Small client-side list of print events — show all rows. The
                    // previous object-pagination was cosmetic (no current/onChange,
                    // and CustomTable does not slice).
                    pagination={false}
                    scroll={{ x: 'auto' }}
                    rowKey={(_record, idx) => `move-print-${idx}`}
                    locale={{
                      emptyText:
                        'No bin label print events recorded for the bins this batch has occupied.'
                    }}
                  />
                </div>
              </div>
            )}
            {type === 'mrr_audit' && (
              <div style={{ marginTop: 24 }}>
                <div style={{ marginBottom: 8 }}>
                  <span
                    style={{ fontSize: 14, fontWeight: 600, color: '#444' }}
                  >
                    MRR Label Print Events
                  </span>
                </div>
                <div className={`${styles.table_container}`}>
                  <CustomTable
                    columns={material_receipt_audit_columns}
                    dataSource={mrrPrintEvents || []}
                    // Small client-side list of print events — show all rows. The
                    // previous object-pagination was cosmetic (no current/onChange,
                    // and CustomTable does not slice).
                    pagination={false}
                    scroll={{ x: 'auto' }}
                    rowKey={(_record, idx) => `mrr-print-${idx}`}
                    locale={{
                      emptyText:
                        'No MRR label print events recorded for this batch/MRR.'
                    }}
                  />
                </div>
              </div>
            )}
            {type === 'material_receipt_audit' && (
              <div style={{ marginTop: 24 }}>
                <div style={{ marginBottom: 8 }}>
                  <span
                    style={{ fontSize: 14, fontWeight: 600, color: '#444' }}
                  >
                    Material Label Print Events
                  </span>
                </div>
                <div className={`${styles.table_container}`}>
                  <CustomTable
                    columns={material_receipt_audit_columns}
                    dataSource={materialPrintEvents || []}
                    // Small client-side list of print events — show all rows. The
                    // previous object-pagination was cosmetic (no current/onChange,
                    // and CustomTable does not slice).
                    pagination={false}
                    scroll={{ x: 'auto' }}
                    rowKey={(_record, idx) => `material-print-${idx}`}
                    locale={{
                      emptyText:
                        'No label print events recorded for this receipt.'
                    }}
                  />
                </div>
              </div>
            )}
          </Card>
        ) : (
          ''
        )}
        <CustomModal
          title={
            reporttype === 'mrr_audit'
              ? 'Multiple MRRs found — select one'
              : reporttype === 'move_material_audit'
              ? 'Multiple batches found — select one'
              : reporttype === 'wip_label_audit'
              ? 'Multiple labelling sessions found — select one'
              : reporttype === 'miscellaneous_label_audit'
              ? 'Miscellaneous containers — select one'
              : reporttype === 'lc_material_verification_audit'
              ? 'Multiple line clearances found — select one'
              : 'Multiple receipts found — select one'
          }
          visible={candidate_modal_open}
          footer={null}
          width={760}
          onCancel={() => setCandidateModalOpen(false)}
        >
          <CustomTable
            columns={
              reporttype === 'lc_material_verification_audit'
                ? [
                    {
                      title: 'Product Batch',
                      dataIndex: 'product_batch_number',
                      key: 'product_batch_number',
                      width: '140px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: 'Product',
                      dataIndex: 'product_name',
                      key: 'product_name',
                      width: '200px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: 'Process',
                      dataIndex: 'process',
                      key: 'process',
                      width: '130px',
                      render: (text, record) =>
                        `${text || 'N/A'}${
                          record.sub_process && record.sub_process !== 'N/A'
                            ? ` › ${record.sub_process}`
                            : ''
                        }`
                    },
                    {
                      title: 'Status',
                      dataIndex: 'material_verify_status',
                      key: 'material_verify_status',
                      width: '110px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: '',
                      key: 'select',
                      width: '90px',
                      render: (_text, record) => (
                        <CustomButton
                          type="primary"
                          size="small"
                          onClick={() => {
                            setCandidateModalOpen(false);
                            loadLcMatVerTimeline(record.id);
                          }}
                        >
                          Select
                        </CustomButton>
                      )
                    }
                  ]
                : reporttype === 'mrr_audit'
                ? [
                    {
                      title: 'MRR Number',
                      dataIndex: 'MRR_number',
                      key: 'MRR_number',
                      width: '160px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: 'Product Batch',
                      dataIndex: 'product_batch_number',
                      key: 'product_batch_number',
                      width: '160px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: 'Product',
                      dataIndex: 'product_name',
                      key: 'product_name',
                      width: '220px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: 'Status',
                      dataIndex: 'status',
                      key: 'status',
                      width: '140px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: '',
                      key: 'select',
                      width: '90px',
                      render: (_text, record) => (
                        <CustomButton
                          type="primary"
                          size="small"
                          onClick={() => {
                            setCandidateModalOpen(false);
                            loadMrrTimeline(record);
                          }}
                        >
                          Select
                        </CustomButton>
                      )
                    }
                  ]
                : reporttype === 'move_material_audit'
                ? [
                    {
                      title: 'Batch Number',
                      dataIndex: 'number',
                      key: 'number',
                      width: '160px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: 'Kind',
                      dataIndex: 'kind',
                      key: 'kind',
                      width: '110px',
                      render: (text) =>
                        text === 'raw' ? 'Raw Material' : 'Product / WIP'
                    },
                    {
                      title: 'Material',
                      dataIndex: 'material_name',
                      key: 'material_name',
                      width: '200px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: 'Status',
                      dataIndex: 'current_status',
                      key: 'current_status',
                      width: '140px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: '',
                      key: 'select',
                      width: '90px',
                      render: (_text, record) => (
                        <CustomButton
                          type="primary"
                          size="small"
                          onClick={() => {
                            setCandidateModalOpen(false);
                            loadMoveMaterialTimeline(record);
                          }}
                        >
                          Select
                        </CustomButton>
                      )
                    }
                  ]
                : reporttype === 'wip_label_audit'
                ? [
                    {
                      title: 'Process',
                      dataIndex: 'process',
                      key: 'process',
                      width: '140px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: 'Lot',
                      dataIndex: 'lot_no',
                      key: 'lot_no',
                      width: '80px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: 'Next Process',
                      dataIndex: 'next_process',
                      key: 'next_process',
                      width: '160px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: 'Containers',
                      dataIndex: 'containers',
                      key: 'containers',
                      width: '90px',
                      render: (text) =>
                        text === 0 || text ? String(text) : 'N/A'
                    },
                    {
                      title: 'Last Updated',
                      dataIndex: 'last_updated',
                      key: 'last_updated',
                      width: '180px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: '',
                      key: 'select',
                      width: '90px',
                      render: (_text, record) => (
                        <CustomButton
                          type="primary"
                          size="small"
                          onClick={() => {
                            setCandidateModalOpen(false);
                            loadWipLabelTimelineById(record.id);
                          }}
                        >
                          Select
                        </CustomButton>
                      )
                    }
                  ]
                : reporttype === 'miscellaneous_label_audit'
                ? [
                    {
                      title: 'Container',
                      dataIndex: 'msc_containers',
                      key: 'msc_containers',
                      width: '140px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: 'Description',
                      dataIndex: 'description',
                      key: 'description',
                      width: '220px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: 'Created',
                      dataIndex: 'created',
                      key: 'created',
                      width: '180px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: 'User',
                      dataIndex: 'user',
                      key: 'user',
                      width: '160px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: '',
                      key: 'select',
                      width: '90px',
                      render: (_text, record) => (
                        <CustomButton
                          type="primary"
                          size="small"
                          onClick={() => {
                            setCandidateModalOpen(false);
                            loadMscLabelTimelineById(record.id);
                          }}
                        >
                          Select
                        </CustomButton>
                      )
                    }
                  ]
                : [
                    {
                      title: 'Created',
                      dataIndex: 'createdAt',
                      key: 'createdAt',
                      width: '140px',
                      render: (text) =>
                        text ? moment(text).format('DD MMM YYYY HH:mm') : 'N/A'
                    },
                    {
                      title: 'Material',
                      dataIndex: 'material_name',
                      key: 'material_name',
                      width: '200px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: 'Supplier',
                      dataIndex: 'supplier_name',
                      key: 'supplier_name',
                      width: '180px',
                      render: (text) => text || 'N/A'
                    },
                    {
                      title: 'Status',
                      dataIndex: 'qa_status',
                      key: 'qa_status',
                      width: '120px',
                      render: (text) =>
                        text === null ? 'MRN INITIATED' : 'QA PENDING'
                    },
                    {
                      title: '',
                      key: 'select',
                      width: '90px',
                      render: (_text, record) => (
                        <CustomButton
                          type="primary"
                          size="small"
                          onClick={() => {
                            setCandidateModalOpen(false);
                            loadMaterialReceiptAuditByDocId(record.id);
                          }}
                        >
                          Select
                        </CustomButton>
                      )
                    }
                  ]
            }
            dataSource={candidate_rows}
            pagination={false}
            showPaginationMeta={false}
          />
        </CustomModal>
        <CustomModal
          title="Select receipts to combine (up to 5)"
          visible={receipt_range_modal_open}
          footer={null}
          width={820}
          onCancel={() => setReceiptRangeModalOpen(false)}
        >
          {receipt_range_truncated && (
            <div style={{ marginBottom: 10, color: '#ad6800' }}>
              Showing the most recent {receipt_range_rows.length} receipts for
              this range. Narrow the dates to see older ones.
            </div>
          )}
          <CustomTable
            rowKey="id"
            rowSelection={{
              selectedRowKeys: receipt_range_selected,
              // Keep ticks from other pages even though those rows are not in
              // the current page slice — gives true cross-page persistence.
              preserveSelectedRowKeys: true,
              onChange: (keys) => setReceiptRangeSelected(keys),
              getCheckboxProps: (record) => ({
                disabled:
                  receipt_range_selected.length >= RECEIPT_COMBINE_MAX &&
                  !receipt_range_selected.includes(record.id)
              })
            }}
            columns={[
              {
                title: 'Created',
                dataIndex: 'createdAt',
                key: 'createdAt',
                width: '150px',
                render: (text) =>
                  text ? moment(text).format('DD MMM YYYY HH:mm') : 'N/A'
              },
              {
                title: 'Invoice',
                dataIndex: 'invoice_number',
                key: 'invoice_number',
                width: '150px',
                render: (text) => text || 'N/A'
              },
              {
                title: 'Material',
                dataIndex: 'material_name',
                key: 'material_name',
                width: '200px',
                render: (text) => text || 'N/A'
              },
              {
                title: 'Supplier',
                dataIndex: 'supplier_name',
                key: 'supplier_name',
                width: '170px',
                render: (text) => text || 'N/A'
              },
              {
                title: 'Status',
                dataIndex: 'qa_status',
                key: 'qa_status',
                width: '120px',
                render: (text) =>
                  text === null || text === undefined
                    ? 'MRN INITIATED'
                    : 'QA PENDING'
              }
            ]}
            dataSource={receipt_range_rows.slice(
              (receipt_range_page - 1) * RECEIPT_PAGE_SIZE,
              receipt_range_page * RECEIPT_PAGE_SIZE
            )}
            pagination={{
              current: receipt_range_page,
              pageSize: RECEIPT_PAGE_SIZE,
              total: receipt_range_rows.length,
              onChange: (p) => setReceiptRangePage(p)
            }}
            showPaginationMeta={false}
          />
          {receipt_range_selected.length > 0 && (
            <div style={{ marginTop: 12 }}>
              <span style={{ color: '#595959', marginRight: 6 }}>
                Selected receipts:
              </span>
              {receipt_range_rows
                .filter((r) => receipt_range_selected.includes(r.id))
                .map((r) => (
                  <Tag
                    key={r.id}
                    closable
                    color="blue"
                    onClose={(e) => {
                      e.preventDefault();
                      setReceiptRangeSelected(
                        receipt_range_selected.filter((id) => id !== r.id)
                      );
                    }}
                    style={{ marginBottom: 4 }}
                  >
                    {r.invoice_number || `#${r.id}`}
                  </Tag>
                ))}
            </div>
          )}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: 16
            }}
          >
            <span style={{ fontWeight: 600, color: '#1a3c5e' }}>
              {receipt_range_selected.length} of {RECEIPT_COMBINE_MAX} receipts
              selected
            </span>
            <Space>
              <CustomButton
                type="primary"
                ghost
                onClick={() => setReceiptRangeModalOpen(false)}
              >
                Cancel
              </CustomButton>
              <CustomButton
                type="primary"
                loading={combinedPdfLoading}
                disabled={
                  combinedPdfLoading || receipt_range_selected.length === 0
                }
                onClick={generateCombinedReceiptPdf}
              >
                {combinedPdfLoading ? 'Generating...' : 'Generate Combined PDF'}
              </CustomButton>
            </Space>
          </div>
        </CustomModal>
      </Form>
    </Layout>
  );
};
export default ViewAuditTrailsPage;
